import { IonAlert, IonButton, IonButtons, IonCard, IonCardContent, IonChip, IonCol, IonContent, IonFab, IonFabButton, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonLoading, IonModal, IonPage, IonRow, IonTitle, IonToast, IonToolbar, isPlatform, useIonAlert, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { addCircle, arrowBack, arrowDown, arrowUp, pencilOutline, pricetagOutline, printOutline, removeCircle, swapHorizontalOutline, trash } from 'ionicons/icons';
import QRCode from 'qrcode';
import React, { createRef, useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { adicionarImpressaoNaFila, criarJobImpressao } from '../../../../../Utils/PrintQueueHelper';
import { alterarMesa, alterarStatusProjeto, empresaCarregar, enviarMesa, mesaGerarCupom, projetoGerarCupomParcial, requestService, urlBaseCore } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import ComandasFechar from '../ComandasFechar/ComandasFechar';
import type { DescontoPayload } from '../Desconto/Desconto';
import Desconto, { converterDescontoParaValorMonetario, resolverDescontoInicial } from '../Desconto/Desconto';
import OrdensProdutosCompor from '../OrdensProdutosCompor/OrdensProdutosCompor';
import TaxaServico from '../TaxaServico/TaxaServico';
import Transferir from '../Transferir/Transferir';
import "./ComandasProdutosMemory.css";

type Props = {
  id: any;
  nome: any;
};

const ComandasProdutosMemory: React.FC<Props> = (props: Props) => {

  // Hooks de navegação
  const history = useHistory<any>();
  const location = useLocation<any>();

  // Estados relacionados a loading e feedback visual
  const [mostartAlerta] = useIonAlert();
  const [showLoading, setShowLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  // Estados de modais e alertas
  const [showComandasFechar, setShowComandasFechar] = useState(false);
  const [showModalTaxaServico, setShowModalTaxaServico] = useState(false);
  const [showModalDesconto, setShowModalDesconto] = useState(false);
  const [showModalTransferir, setShowModalTransferir] = useState(false);
  const [alertRegistrar, setAlertRegistrar] = useState(false);
  const [showHabilitarEdicao, setShowHabilitarEdicao] = useState(false);

  // Estados de controle de exibição
  const [stateShowMenu, setStateShowMenu] = useState(!true);
  const [stateShowCaixa, setStateShowCaixa] = useState(!true);

  // Estados de valores e listas
  const [listaItemProdutos, setListaItemProdutos] = useState<any>([]);
  const [dadosComandas, setDadosComandas] = useState<any>([]);
  const [listaAnteriorParaCancelar, setListaAnteriorParaCancelar] = useState<any>([]);
  const [valorTotalProdutos, setValorTotalProdutos] = useState<any>();
  const [valorTotal, setValorTotal] = useState<any>();
  const [descontoSelecionado, setDescontoSelecionado] = useState<DescontoPayload | undefined>(undefined);
  const [reloadCatalogo, setReloadCatalogo] = useState(false);

  // Contextos
  const { loja, setLoja } = useContext(MessageContext);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);
  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);

  // Outros estados e referências
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const buscarInputRef = useRef<any>(null);
  const contentCatalogoRef = useRef<any>(null);
  const contentRef = createRef<HTMLIonContentElement>();
  const [mostrarAlerta] = useIonAlert();

  // Estado para armazenar valor persistido no localStorage
  // const [imprimirMesaParcial, setImprimirComandasParcial] = useState<boolean>(() => {
  //   const storedValue = window.localStorage.getItem("imprimirMesaParcial");
  //   return storedValue === "true";
  // });

  // Estado para armazenar valor persistido no localStorage
  const [impressoraBluetoothHabilitar, setImpressoraBluetoothHabilitar] = useState<boolean>(() => {
    const storedValue = window.localStorage.getItem("impressoraBluetoothHabilitar");
    return storedValue === "true";
  });

  const [impressoraBluetoothSPPHabilitar, setImpressoraBluetoothSPPHabilitar] = useState<boolean>(() => {
    const storedValue = window.localStorage.getItem("impressoraBluetoothSPPHabilitar");
    return storedValue === "true";
  });

  const [impressoraLocalHabilitar, setImpressoraLocalHabilitar] = useState<boolean>(() => {
    const storedValue = window.localStorage.getItem("impressoraLocalHabilitar");
    return storedValue === "true";
  });

  const [impressoraRedeHabilitar, setImpressoraRedeHabilitar] = useState<boolean>(() => {
    const storedValue = window.localStorage.getItem("impressoraRedeHabilitar");
    return storedValue === "true";
  });

  // Funções de rolagem
  const scrollToTop = () => {
    if (contentRef.current) {
      contentRef.current.scrollToTop();
    }
    setStateShowMenu(!true);
    setStateShowCaixa(!false);
  };

  const scrollToBottom = () => {
    if (contentRef.current) {
      contentRef.current.scrollToBottom();
    }
    setStateShowMenu(!false);
    setStateShowCaixa(!true);
  };

  const scrollToCatalogo = () => {
    contentCatalogoRef.current && contentCatalogoRef.current.scrollIntoView();
  };

  let params: any = {
    id: ""
  }
  params = useParams();

  if (location && location.state && location.state.id) {
    params.id = location.state.id;
  }

  if (props.id) {
    params = {
      id: props.id,
    }
  }

  useEffect(() => {
    if (params.id) {
      console.log("entrou no useEffect");
      carregarComanda();
      carregarEmpresa();
    }
  }, [params.id]);

  useEffect(() => {

    try {
      let taxaServicoFloat = parseFloat(dadosComandas.taxaServico?.replace(/\./g, '').replace(/\,/g, '.'));
      let descontoFloat = parseFloat(dadosComandas.desconto?.replace(/\./g, '').replace(/\,/g, '.'));
      let taxaEntregaFloat = parseFloat(dadosComandas.taxaEntrega?.replace(/\./g, '').replace(/\,/g, '.'));

      let valorTotalRecalculado = 0;
      if (valorTotalProdutos) {
        valorTotalRecalculado = parseFloat(valorTotalProdutos.replace(/\./g, '').replace(/\,/g, '.'));
      }

      if (dadosComandas.taxaEntrega) {
        valorTotalRecalculado += (taxaEntregaFloat ? taxaEntregaFloat : 0);
      }

      if (dadosComandas.desconto) {
        valorTotalRecalculado += - (descontoFloat ? descontoFloat : 0);
      }
      if (dadosComandas.taxaServico) {
        valorTotalRecalculado += (valorTotalRecalculado * (taxaServicoFloat / 100));
      }

      setValorTotal(valorTotalRecalculado.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }));

    } catch (error) {
      console.log("erro ao calcular", error);
    }
  }, [valorTotalProdutos]);

  useEffect(() => {
    setDescontoSelecionado((atual) => resolverDescontoInicial(dadosComandas.desconto, valorTotalProdutos, atual));
  }, [dadosComandas.desconto, valorTotalProdutos]);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
  });

  function carregarEmpresa() {

    const consultar = async () => {

      requestService(empresaCarregar.url.replace("{id}", loja.replaceAll(/#/g, '%23')).concat("?filtro=", Buffer.from(loja).toString("base64")), {
        method: empresaCarregar.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          setDadosEmpresa(response.Item);
          setShowLoading(false);
        },
        (error: any) => {
          console.log(error);
          history.replace("/login/");
        });

    }

    consultar();
  }

  function carregarComanda() {

    const consultar = async () => {
      var token: string = "";
      var tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") { token = tkn; }
      setShowLoading(true);
      const resp = await fetch(urlBaseCore.url + "/ordens/" + params.id.replaceAll(/#/g, "%23") + "/semassinar",
        {
          method: urlBaseCore.method,
          headers: [
            ["token", token]
          ],
          credentials: 'include'
        }).finally(() => {
          setShowLoading(false);
        });
      const response = await resp.json();
      if (response.Item !== undefined) {

        setDadosComandas(response.Item);
        setListaItemProdutos(response.Item.produtos || []);

        setValorTotalProdutos((response.Item.valorTotalProdutos || 0).toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }));
      }

      if (buscarInputRef.current) {
        buscarInputRef.current.setFocus();
      }
    }

    consultar();
  }

  async function adicionarItem(produto: any) {

    if (produto) {

      let updatedList = [...listaItemProdutos, produto];

      setListaItemProdutos(updatedList);


      let totalValor = updatedList.reduce((total: any, item: any) => {
        const itemValorNumerico = parseFloat(
          item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
        );
        return total + itemValorNumerico;
      }, 0);

      setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }));

      if (window.innerWidth < 768) {
        setTextToast("Item adicionado com sucesso.");
        setShowToast(true);
      }

    }
    scrollToCatalogo();
  }

  function deletarItemProdutos(index: number) {
    // Filtra a lista de produtos, removendo o item com o índice fornecido
    const updatedList = listaItemProdutos.filter((_: any, i: any) => i !== index);

    // Atualiza a lista de produtos com o item removido
    setListaItemProdutos(updatedList);

    // Calcula a nova soma dos valores após a remoção
    const totalValor = updatedList.reduce((total: any, item: any) => {
      const itemValorNumerico = parseFloat(
        item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
      );
      return total + itemValorNumerico;
    }, 0);

    // Exemplo: você pode armazenar a nova soma em outro estado ou usar conforme necessário
    console.log("Nova soma dos valores:", totalValor);

    setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }));

  }

  async function alterarConta(marcarComoEnviado: any = false) {

    return new Promise<void>(async (resolve, reject) => {

      let objRequest = {
        "produtos": listaItemProdutos,
        "enviado": marcarComoEnviado

      };

      requestService(alterarMesa.url.replaceAll("{id}", params.id.replaceAll(/#/g, '%23')), {
        method: alterarMesa.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(objRequest),
        credentials: 'include'
      },
        history,
        async (response: any) => {


          if (response.dadosPedido && response.dadosPedido.Attributes) {

            setDadosComandas(response.dadosPedido.Attributes);
            setListaItemProdutos(response.dadosPedido.Attributes.produtos || []);

            setValorTotalProdutos((response.dadosPedido.Attributes.valorTotalProdutos || 0).toLocaleString('pt-br', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }));

            // Atualizar dadosEmpresa se retornado na resposta
            if (response.dadosEmpresa && response.dadosEmpresa.Attributes) {
              // Atualiza o contexto global com o novo objeto
              setDadosEmpresa(response.dadosEmpresa.Attributes);

              // Sinaliza reload do catálogo (o componente irá resetar para false automaticamente)
              setReloadCatalogo(true);
            }

            resolve(response.dadosPedido.Attributes);


          }
          else {
            reject(new Error("Erro: Resposta inválida ou incompleta."));
          }
        },
        (error: any) => {
          console.log(error);
          reject(error);  // Promessa rejeitada com erro
        });
    });
  }

  async function salvar(marcarComoEnviado: any = false) {

    return new Promise<void>(async (resolve, reject) => {

      let objRequest = {
        "produtos": listaItemProdutos,
        "enviado": marcarComoEnviado

      };

      requestService(enviarMesa.url.replaceAll("{id}", params.id.replaceAll(/#/g, '%23')), {
        method: enviarMesa.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        body: JSON.stringify(objRequest),
        credentials: 'include'
      },
        history,
        async (response: any) => {


          if (response.message && response.message.Attributes) {

            setDadosComandas(response.message.Attributes);
            setListaItemProdutos(response.message.Attributes.produtos || []);

            setValorTotalProdutos((response.message.Attributes.valorTotalProdutos || 0).toLocaleString('pt-br', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }));

            resolve(response.message.Attributes);

          }
          else {
            reject(new Error("Erro: Resposta inválida ou incompleta."));
          }
        },
        (error: any) => {
          console.log(error);
          reject(error);  // Promessa rejeitada com erro
        });
    });
  }

  async function alterar(
    formaPagamento: any,
    taxaServico: any,
    taxaEntrega: any,
    desconto: any
  ) {
    return new Promise((resolve, reject) => {
      const objectRequest = {
        formaPagamento: formaPagamento, //formaPagamento,
        // troco: calcularValorTroco(valorTotal, arrayFormaPagamento),
        taxaEntrega: taxaEntrega,
        taxaServico: taxaServico,
        desconto: desconto,
      };

      requestService(
        alterarStatusProjeto.url.replaceAll("{id}", params.id.replaceAll(/#/g, "%23")) + "?alteracao=true",
        {
          method: alterarStatusProjeto.method,
          headers: [["token", localStorage.getItem("token") || ""]],
          credentials: "include",
          body: JSON.stringify(objectRequest),
        },
        history,
        (response: any) => {
          // console.log("response", response);
          setDadosComandas(response);
          setValorTotal((response.valorTotal || 0).toLocaleString('pt-br', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }));
          resolve(response); // Resolve a Promise se a alteração for bem-sucedida
        },
        (error: any) => {
          setTextToast(error.message);
          setShowToast(true);
          reject(error); // Rejeita a Promise se houver erro
        }
      );
    });
  }

  function gerarEscPosParcial(projeto: any, imprimir58mm: any = false, fonteGrande: boolean = false) {
    // Função para remover acentos e cedilhas
    function removerAcentosECedilha(texto: string): string {
      return texto
        .normalize('NFD')  // Normaliza o texto para decompô-lo em caracteres base e acentos
        .replace(/[\u0300-\u036f]/g, '')  // Remove os acentos
        .replace(/ç/g, 'c')  // Substitui 'ç' por 'c'
        .replace(/Ç/g, 'C');  // Substitui 'Ç' por 'C'
    }

    // Função para formatar valores monetários
    const formatarValor = (valor: any) => {
      if (!valor) return '0,00';

      // Remove pontos de milhares e substitui a vírgula decimal por ponto
      const valorNumerico = parseFloat(valor.toString().replace(/\./g, '').replace(',', '.'));

      // Formata o número para o padrão brasileiro
      return valorNumerico.toFixed(2).replace('.', ',');
    };

    function gerarCabecalho(projeto: any, empresa: any) {
      let cabecalhoText = "";

      // // Informações da empresa
      cabecalhoText += `${empresa?.empresaNome}\n`;
      // cabecalhoText += `CNPJ: ${aplicarMascaraCPFouCNPJ(empresa?.empresaCnpj)}\n`;

      // // Endereço da empresa
      // quebrarTextoEmLinhas(`Endereço: ${empresa.empresaEndereco}`, 35).forEach((linha: any) => {
      //   cabecalhoText += `${linha}\n`;
      // });

      // cabecalhoText += `Tel: ${formataTelefone(empresa?.empresaTelefone)}\n`;

      // Data e hora do cupom, se disponível
      if (projeto.dataCupom) {
        cabecalhoText += `Data: ${new Date(projeto.dataCupom).toLocaleDateString('pt-BR')} Hora: ${new Date(projeto.dataCupom).toLocaleTimeString('pt-BR')}\n`;
      }

      cabecalhoText += imprimir58mm ? `********************************\n` : `**************************************\n`;

      // Informações do cliente
      cabecalhoText += `${projeto.clienteNome}\n`;

      return cabecalhoText;
    }

    // Função para gerar o corpo do cupom (produtos)
    function gerarProdutos(projeto: any) {
      const ESC = 0x1B;  // ESC
      const SUBLINHADO_ON = [ESC, 0x2D, 0x01];
      const SUBLINHADO_OFF = [ESC, 0x2D, 0x00];

      let produtosText = "";
      const larguraProduto = imprimir58mm ? 32 : 38;

      const quebrarTextoProdutoEmLinhas = (texto: string, tamanhoMaximo: number) => {
        const conteudo = String(texto || "").trim();
        if (!conteudo) return [];

        const palavras = conteudo.split(/\s+/);
        let linhas: string[] = [];
        let linhaAtual = "";

        palavras.forEach((palavra: string) => {
          let restante = String(palavra);

          while (restante.length > 0) {
            const proximaLinha = linhaAtual ? `${linhaAtual} ${restante}` : restante;

            if (proximaLinha.length <= tamanhoMaximo) {
              linhaAtual = proximaLinha;
              restante = "";
            } else if (linhaAtual) {
              linhas.push(linhaAtual);
              linhaAtual = "";
            } else {
              linhas.push(restante.slice(0, tamanhoMaximo));
              restante = restante.slice(tamanhoMaximo);
            }
          }
        });

        if (linhaAtual) {
          linhas.push(linhaAtual);
        }

        return linhas;
      };

      const adicionarLinhasProduto = (
        texto: string,
        prefixoPrimeiraLinha: string,
        prefixoDemaisLinhas: string = " ".repeat(prefixoPrimeiraLinha.length),
        sublinhar: boolean = false
      ) => {
        const larguraConteudo = Math.max(8, larguraProduto - Math.max(prefixoPrimeiraLinha.length, prefixoDemaisLinhas.length));

        quebrarTextoProdutoEmLinhas(texto, larguraConteudo).forEach((linha: string, indiceLinha: number) => {
          const prefixo = indiceLinha === 0 ? prefixoPrimeiraLinha : prefixoDemaisLinhas;

          if (sublinhar) {
            produtosText += `${prefixo}${String.fromCharCode(...SUBLINHADO_ON)}${linha}${String.fromCharCode(...SUBLINHADO_OFF)}\n`;
          } else {
            produtosText += `${prefixo}${linha}\n`;
          }
        });
      };

      produtosText += "QTDE | DESCRIÇÃO\n";
      produtosText += imprimir58mm ? `--------------------------------\n` : `--------------------------------------\n`;

      if (projeto.produtos && Array.isArray(projeto.produtos) && projeto.produtos.length > 0) {
        projeto.produtos.filter((prod: any) => (!prod.impresso)).forEach((produto: any) => {
          // Verifica se o produto possui uma descrição complexa
          if (Array.isArray(produto.descricao)) {
            produto.descricao.forEach((itemDesc: any, indexLinha: number) => {
              // Exibe a linha principal do produto apenas uma vez
              if (indexLinha === 0) {
                const prefixoPrincipal = `${produto.quantidade} | `;
                const descricaoPrincipal = produto.tipo === "pizzas"
                  ? `${produto.tamanho} ${produto.quantidadeSabores} ${produto.quantidadeSabores === 1 ? "SABOR" : "SABORES"} (R$ ${formatarValor(produto.valor)})`
                  : `${produto.categoria} (R$ ${formatarValor(produto.valor)})`;

                adicionarLinhasProduto(descricaoPrincipal, prefixoPrincipal);
              }

              // Exibe as descrições adicionais, se houver
              if (itemDesc.descricao) {
                if (itemDesc.categoria == "Observação") {
                  adicionarLinhasProduto(`Observação: ${itemDesc.descricao}`, "  ", "  ", true);
                }
                else {
                  adicionarLinhasProduto(`${itemDesc.descricao} (R$ ${formatarValor(itemDesc.valor)})`, "  - ", "    ");
                }
              }
            });
          } else {
            // Para produtos com uma única descrição simples
            adicionarLinhasProduto(`${produto.descricao} (R$ ${formatarValor(produto.valor)})`, `${produto.quantidade} | `);
          }

          // Adiciona o subtotal de cada produto
          produtosText += `VALOR: R$ ${formatarValor(produto.subtotal)}\n`;
          produtosText += imprimir58mm ? `--------------------------------\n` : `--------------------------------------\n`;
        });

      }

      return produtosText;
    }

    try {


      console.log("dadosImpressao1");
      // Montando o cupom com os dados no formato ESC/POS
      const cabecalho = gerarCabecalho(projeto, dadosEmpresa);

      console.log("cabecalho", cabecalho);
      const produtos = gerarProdutos(projeto);
      console.log("produtos", produtos);

      // Comandos ESC/POS básicos

      const ESC = 0x1B;  // ESC
      const LF = 0x0A;   // Line Feed
      const GS = 0x1D;
      const CORTA_PAPEL = [ESC, 0x69];   // Corta Papel
      const NEGRITO_ON = [ESC, 0x45, 0x01];  // Ativar negrito
      const NEGRITO_OFF = [ESC, 0x45, 0x00]; // Desativar negrito
      const ALIMENTAR_PAPEL = [ESC, 0x64, 0x10]; // Alimentação de papel
      const FONTE_NORMAL = [GS, 0x21, 0x00];
      const FONTE_GRANDE = [GS, 0x21, 0x01]; // 2x altura


      const dadosImpressao: any = [
        // ...ALIMENTAR_PAPEL, // Alimentação de papel
        LF,
        ...(fonteGrande ? FONTE_GRANDE : FONTE_NORMAL),
        ...NEGRITO_ON,
        ...removerAcentosECedilha(cabecalho).split("").map(c => c.charCodeAt(0)),
        ...NEGRITO_OFF, // Desativar negrito
        LF, // Pular linha
        ...removerAcentosECedilha(produtos).split("").map(c => c.charCodeAt(0)),
        // LF, // Pular linha
        // ...removerAcentosECedilha(rodape).split("").map(c => c.charCodeAt(0)),
        ...FONTE_NORMAL,
        LF, LF, LF, LF, LF,
        // ...ALIMENTAR_PAPEL, // Alimentação de papel
        ...CORTA_PAPEL

      ];

      // Retorna os dados como Uint8Array
      return new Uint8Array(dadosImpressao);
    } catch (error) {
      console.error('Erro ao imprimir cupom:', error);
      return null; // Retorna null em caso de erro
    }
  }

  function gerarEscPos(projeto: any, imprimir58mm: any = false, fonteGrande: boolean = false) {
    // Função para remover acentos e cedilhas
    function removerAcentosECedilha(texto: string): string {
      return texto
        .normalize('NFD')  // Normaliza o texto para decompô-lo em caracteres base e acentos
        .replace(/[\u0300-\u036f]/g, '')  // Remove os acentos
        .replace(/ç/g, 'c')  // Substitui 'ç' por 'c'
        .replace(/Ç/g, 'C');  // Substitui 'Ç' por 'C'
    }

    // Função para aplicar a máscara de CPF/CNPJ
    function aplicarMascaraCPFouCNPJ(texto: any) {
      if (!texto) return '';
      texto = texto.replace(/\D/g, '');
      if (texto.length === 11) {
        return texto.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else if (texto.length === 14) {
        return texto.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
      return texto;
    }

    // Função para formatar telefone
    function formataTelefone(numero: any) {
      if (numero?.length == 13) {
        let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
        BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
        return BRNumber;
      }
      else if (numero?.length == 12) {
        let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
        BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
        return BRNumber;
      }
      else { return "" };
    }

    function quebrarTextoEmLinhas(texto: any, tamanhoMaximo: any) {
        const conteudo = String(texto || '').trim();
        if (!conteudo) return [];

        const palavras = conteudo.split(/\s+/);
      let linhas = [];
      let linhaAtual = '';

      palavras.forEach((palavra: any) => {
          let restante = String(palavra);

          while (restante.length > 0) {
            const proximaLinha = linhaAtual ? `${linhaAtual} ${restante}` : restante;

            if (proximaLinha.length <= tamanhoMaximo) {
              linhaAtual = proximaLinha;
              restante = '';
            } else if (linhaAtual) {
              linhas.push(linhaAtual);
              linhaAtual = '';
            } else {
              linhas.push(restante.slice(0, tamanhoMaximo));
              restante = restante.slice(tamanhoMaximo);
            }
        }
      });

        if (linhaAtual) {
          linhas.push(linhaAtual);
      }

      return linhas;
    }

    // Função para formatar valores monetários
    const formatarValor = (valor: any) => {
      if (!valor) return '0,00';

      // Remove pontos de milhares e substitui a vírgula decimal por ponto
      const valorNumerico = parseFloat(valor.toString().replace(/\./g, '').replace(',', '.'));

      // Formata o número para o padrão brasileiro
      return valorNumerico.toFixed(2).replace('.', ',');
    };

    const formatarTaxa = (valor: any) => {
      if (!valor) return '0';

      // Remove pontos de milhares e substitui a vírgula decimal por ponto
      const valorNumerico = parseFloat(valor.toString().replace(/\./g, '').replace(',', '.'));

      // Formata o número para o padrão brasileiro
      return valorNumerico;
    };

    // Função para gerar o cabeçalho e as informações do cupom
    function gerarCabecalho(projeto: any, empresa: any) {
      const ESC = 0x1B;  // ESC
      const SUBLINHADO_ON = [ESC, 0x2D, 0x01];
      const SUBLINHADO_OFF = [ESC, 0x2D, 0x00];

      let cabecalhoText = "";

      // Informações da empresa
      cabecalhoText += `${empresa?.empresaNome}\n`;
      cabecalhoText += `CNPJ: ${aplicarMascaraCPFouCNPJ(empresa?.empresaCnpj)}\n`;

      // Endereço da empresa
      quebrarTextoEmLinhas(`Endereço: ${empresa.empresaEndereco}`, imprimir58mm ? 32 : 38).forEach((linha: any) => {
        cabecalhoText += `${linha}\n`;
      });

      cabecalhoText += `Tel: ${formataTelefone(empresa?.empresaTelefone)}\n`;

      // Data e hora do cupom, se disponível
      if (projeto.dataCupom) {
        cabecalhoText += `Data: ${new Date(projeto.dataCupom).toLocaleDateString('pt-BR')} Hora: ${new Date(projeto.dataCupom).toLocaleTimeString('pt-BR')}\n`;
      }

      cabecalhoText += imprimir58mm ? `********************************\n` : `**************************************\n`;

      // Informações do cliente
      cabecalhoText += `${projeto.clienteNome}\n`;

      // Se o projeto não for interno, exibe informações adicionais do cliente
      if (!projeto.interno) {
        cabecalhoText += `Tel: ${formataTelefone(projeto.clienteTelefone)}\n`;

        // Endereço do cliente, se disponível
        quebrarTextoEmLinhas(`Endereço: ${[projeto.endereco, projeto.complemento].filter(Boolean).join(', ') || ""}`, imprimir58mm ? 32 : 38).forEach((linha: any) => {
          cabecalhoText += `${linha}\n`;
        });
      }

      cabecalhoText += imprimir58mm ? `********************************\n` : `**************************************\n`;
      cabecalhoText += "CUPOM NÃO FISCAL\n";

      // Se o projeto não for interno, exibe o nome do projeto
      if (projeto.nomeProjeto) {
        cabecalhoText += imprimir58mm ? `================================\n` : `======================================\n`;
        quebrarTextoEmLinhas(`${empresa?.servicoTipo || "Projeto"}: ${projeto.nomeProjeto}`, imprimir58mm ? 32 : 38).forEach((linha: string) => {
          cabecalhoText += `${String.fromCharCode(...SUBLINHADO_ON)}${linha}${String.fromCharCode(...SUBLINHADO_OFF)}\n`;
        });
        cabecalhoText += imprimir58mm ? `================================\n` : `======================================\n`;
      }

      return cabecalhoText;
    }

    // Função para gerar o corpo do cupom (produtos)
    function gerarProdutos(projeto: any) {
      const ESC = 0x1B;  // ESC
      const SUBLINHADO_ON = [ESC, 0x2D, 0x01];
      const SUBLINHADO_OFF = [ESC, 0x2D, 0x00];

      let produtosText = "";
      const larguraProduto = imprimir58mm ? 32 : 38;

      const adicionarLinhasProduto = (
        texto: string,
        prefixoPrimeiraLinha: string,
        prefixoDemaisLinhas: string = " ".repeat(prefixoPrimeiraLinha.length),
        sublinhar: boolean = false
      ) => {
        const larguraConteudo = Math.max(8, larguraProduto - Math.max(prefixoPrimeiraLinha.length, prefixoDemaisLinhas.length));

        quebrarTextoEmLinhas(texto, larguraConteudo).forEach((linha: string, indiceLinha: number) => {
          const prefixo = indiceLinha === 0 ? prefixoPrimeiraLinha : prefixoDemaisLinhas;

          if (sublinhar) {
            produtosText += `${prefixo}${String.fromCharCode(...SUBLINHADO_ON)}${linha}${String.fromCharCode(...SUBLINHADO_OFF)}\n`;
          } else {
            produtosText += `${prefixo}${linha}\n`;
          }
        });
      };

      produtosText += "QTDE | DESCRIÇÃO\n";
      produtosText += imprimir58mm ? `--------------------------------\n` : `--------------------------------------\n`;

      if (projeto.produtos && Array.isArray(projeto.produtos) && projeto.produtos.length > 0) {
        projeto.produtos.forEach((produto: any) => {
          // Verifica se o produto possui uma descrição complexa
          if (Array.isArray(produto.descricao)) {
            produto.descricao.forEach((itemDesc: any, indexLinha: number) => {
              // Exibe a linha principal do produto apenas uma vez
              if (indexLinha === 0) {
                const prefixoPrincipal = `${produto.quantidade} | `;
                const descricaoPrincipal = produto.tipo === "pizzas"
                  ? `${produto.tamanho} ${produto.quantidadeSabores} ${produto.quantidadeSabores === 1 ? "SABOR" : "SABORES"} (R$ ${formatarValor(produto.valor)})`
                  : `${produto.categoria} (R$ ${formatarValor(produto.valor)})`;

                adicionarLinhasProduto(descricaoPrincipal, prefixoPrincipal);
              }

              // Exibe as descrições adicionais, se houver
              if (itemDesc.descricao) {
                if (itemDesc.categoria == "Observação") {
                  adicionarLinhasProduto(`Observação: ${itemDesc.descricao}`, "  ", "  ", true);
                }
                else {
                  adicionarLinhasProduto(`${itemDesc.descricao} (R$ ${formatarValor(itemDesc.valor)})`, "  - ", "    ");
                }
              }
            });
          } else {
            // Para produtos com uma única descrição simples
            adicionarLinhasProduto(`${produto.descricao} (R$ ${formatarValor(produto.valor)})`, `${produto.quantidade} | `);
          }

          // Adiciona o subtotal de cada produto
          produtosText += `VALOR: R$ ${formatarValor(produto.subtotal)}\n`;
          produtosText += imprimir58mm ? `--------------------------------\n` : `--------------------------------------\n`;
        });

        // Adiciona o total de todos os produtos
        if (projeto.valorTotalProdutos) {
          produtosText += `TOTAL: R$ ${formatarValor(projeto.valorTotalProdutos)}\n`;
        }
      }

      return produtosText;
    }

    // Função para gerar o footer com as informações de pagamento
    function gerarFooter(projeto: any, empresa: any) {
      let pagamentoText = "";
      const larguraRodape = imprimir58mm ? 32 : 38;

      const adicionarLinhasRodape = (texto: string) => {
        quebrarTextoEmLinhas(texto, larguraRodape).forEach((linha: string) => {
          pagamentoText += `${linha}\n`;
        });
      };

      const linhasFormaPagamento = Array.isArray(projeto.formaPagamento)
        ? projeto.formaPagamento
          .map((fp: any) => {
            const nome = fp?.pagamento || fp?.formaPagamentoNome || fp?.tipo;
            const valor = fp?.valor ?? fp?.formaPagamentoValor;

            if (!nome) {
              return "";
            }

            return `${String(nome).toUpperCase()}: R$ ${formatarValor(valor)}`;
          })
          .filter(Boolean)
        : [];

      // Forma de pagamento
      if (projeto.formaPagamento) {
        if (!Array.isArray(projeto.formaPagamento)) {
          pagamentoText += imprimir58mm ? `********************************\n` : `**************************************\n`;
          const linhaPagamento = projeto.formaPagamento?.toLowerCase() === "dinheiro" && projeto.valorPagoDinheiro
            ? `DINHEIRO: R$ ${formatarValor(projeto.valorPagoDinheiro)}`
            : `FORMA PAGAMENTO: ${projeto.formaPagamento?.toUpperCase()}`;

          adicionarLinhasRodape(linhaPagamento);
        }
        else if (linhasFormaPagamento.length > 0) {
          pagamentoText += imprimir58mm ? `********************************\n` : `**************************************\n`;
          pagamentoText += `FORMAS DE PAGAMENTO:\n`;
          linhasFormaPagamento.forEach((linha: string) => adicionarLinhasRodape(linha));
        }
      }

      // Troco, se houver
      if (projeto.troco && projeto.troco !== "0,00") {
        pagamentoText += `TROCO: R$ ${formatarValor(projeto.troco)}\n`;
      }

      // Taxa de entrega, se houver
      if (projeto.taxaServico) {
        pagamentoText += `TAXA: +${formatarTaxa(projeto.taxaServico)}%\n`;
      }

      // Desconto, se houver
      if (projeto.desconto) {
        pagamentoText += `DESCONTO: -R$ ${formatarValor(projeto.desconto)}\n`;
      }

      // Valor total, se houver
      if (projeto.valorTotal) {
        pagamentoText += imprimir58mm ? `********************************\n` : `**************************************\n`;
        pagamentoText += `TOTAL ${empresa.servicoTipo?.toUpperCase() || "PROJETO"}: R$ ${formatarValor(projeto.valorTotal)}\n`;
      }

      return pagamentoText;
    }

    try {


      console.log("dadosImpressao1");
      // Montando o cupom com os dados no formato ESC/POS
      const cabecalho = gerarCabecalho(projeto, dadosEmpresa);

      console.log("cabecalho", cabecalho);
      const produtos = gerarProdutos(projeto);
      console.log("produtos", produtos);
      const rodape = gerarFooter(projeto, dadosEmpresa);
      console.log("rodape", rodape);
      // Comandos ESC/POS básicos

      const ESC = 0x1B;  // ESC
      const LF = 0x0A;   // Line Feed
      const GS = 0x1D;
      const CORTA_PAPEL = [ESC, 0x69];   // Corta Papel
      const NEGRITO_ON = [ESC, 0x45, 0x01];  // Ativar negrito
      const NEGRITO_OFF = [ESC, 0x45, 0x00]; // Desativar negrito
      const ALIMENTAR_PAPEL = [ESC, 0x64, 0x10]; // Alimentação de papel
      const FONTE_NORMAL = [GS, 0x21, 0x00];
      const FONTE_GRANDE = [GS, 0x21, 0x01]; // 2x altura


      const dadosImpressao: any = [
        // ...ALIMENTAR_PAPEL, // Alimentação de papel
        LF,
        ...(fonteGrande ? FONTE_GRANDE : FONTE_NORMAL),
        ...NEGRITO_ON,
        ...removerAcentosECedilha(cabecalho).split("").map(c => c.charCodeAt(0)),
        ...NEGRITO_OFF, // Desativar negrito
        LF, // Pular linha
        ...removerAcentosECedilha(produtos).split("").map(c => c.charCodeAt(0)),
        LF, // Pular linha
        ...removerAcentosECedilha(rodape).split("").map(c => c.charCodeAt(0)),
        ...FONTE_NORMAL,
        LF, LF, LF, LF, LF,
        // ...ALIMENTAR_PAPEL, // Alimentação de papel
        ...CORTA_PAPEL

      ];

      // Retorna os dados como Uint8Array
      return new Uint8Array(dadosImpressao);
    } catch (error) {
      console.error('Erro ao imprimir cupom:', error);
      return null; // Retorna null em caso de erro
    }
  }

  async function gerarEscPosFiscal(cupomFiscal: any, imprimir58mm: boolean = false): Promise<Uint8Array | null> {
    function removerAcentosECedilha(texto: string): string {
      return texto
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ç/g, 'c')
        .replace(/Ç/g, 'C');
    }

    function aplicarMascaraCNPJ(texto: any) {
      if (!texto) return '';
      texto = texto.replace(/\D/g, '');
      if (texto.length === 14) {
        return texto.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
      return texto;
    }

    function quebrarTextoEmLinhas(texto: any, tamanhoMaximo: number) {
      const palavras = texto.split(' ');
      let linhas: string[] = [];
      let linhaAtual = '';
      palavras.forEach((palavra: any) => {
        if ((linhaAtual + palavra).length <= tamanhoMaximo) {
          linhaAtual += palavra + ' ';
        } else {
          linhas.push(linhaAtual.trim());
          linhaAtual = palavra + ' ';
        }
      });
      if (linhaAtual.trim()) linhas.push(linhaAtual.trim());
      return linhas;
    }

    const formatarValor = (valor: any) => {
      if (!valor && valor !== 0) return '0,00';
      return Number(valor).toFixed(2).replace('.', ',');
    };

    const formatarChave = (chave: string) => {
      if (!chave) return '';
      return chave.replace(/(.{4})/g, '$1 ').trim();
    };

    const sep = imprimir58mm ? '================================' : '======================================';
    const sepTraco = imprimir58mm ? '--------------------------------' : '--------------------------------------';
    const largura = imprimir58mm ? 32 : 38;

    try {
      // TODOS os dados vêm exclusivamente de cupomFiscal (extraídos do XML SEFAZ)
      const emitente = cupomFiscal.emitente || {};
      const destinatario = cupomFiscal.destinatario || null;
      const itens = cupomFiscal.itens || [];
      const pagamentos = cupomFiscal.pagamentos || [];
      const totais = cupomFiscal.totais || {};

      let texto = '';

      // Cabeçalho emitente (do XML)
      texto += `${emitente.razaoSocial || emitente.nomeFantasia || ''}\n`;
      texto += `CNPJ: ${aplicarMascaraCNPJ(emitente.cnpj)}\n`;
      if (emitente.ie) texto += `IE: ${emitente.ie}\n`;
      if (emitente.endereco) {
        quebrarTextoEmLinhas(`End: ${emitente.endereco}`, largura).forEach((l: string) => { texto += `${l}\n`; });
      }
      if (destinatario?.cpf) {
        const cpfNumeros = String(destinatario.cpf).replace(/\D/g, '');
        const cpfFormatado = cpfNumeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        texto += `CPF Consumidor: ${cpfFormatado}\n`;
      }

      // Título DANFE
      texto += `${sep}\n`;
      texto += `DANFE NFC-e\n`;
      texto += `NFC-e No ${cupomFiscal.numero || ''} Serie ${cupomFiscal.serie || ''}\n`;
      if (cupomFiscal.dataAutorizacao) {
        const dt = new Date(cupomFiscal.dataAutorizacao);
        texto += `${dt.toLocaleDateString('pt-BR')} ${dt.toLocaleTimeString('pt-BR')}\n`;
      }
      texto += `${sep}\n`;

      // Itens (do XML)
      texto += `COD  DESCRICAO\n`;
      texto += `${sepTraco}\n`;
      itens.forEach((item: any) => {
        const cod = item.codigo || '';
        const desc = item.descricao || 'Item';
        const qtde = Number(item.quantidade || 0);
        const vlUnit = formatarValor(item.valorUnitario);
        const total = formatarValor(item.valorTotal);
        quebrarTextoEmLinhas(`${cod} ${desc}`, largura).forEach((l: string) => { texto += `${l}\n`; });
        texto += `     ${qtde % 1 === 0 ? qtde.toFixed(0) : qtde.toFixed(3)} ${item.unidade || 'UN'} x ${vlUnit}   ${total}\n`;
      });
      texto += `${sepTraco}\n`;

      // Totais (do XML)
      if (totais.desconto > 0) texto += `DESCONTO: -R$ ${formatarValor(totais.desconto)}\n`;
      texto += `TOTAL: R$ ${formatarValor(totais.valorNota)}\n`;
      if (totais.troco > 0) texto += `TROCO: R$ ${formatarValor(totais.troco)}\n`;

      // Pagamentos (do XML — sempre array)
      texto += `${sep}\n`;
      texto += `FORMA DE PAGAMENTO:\n`;
      pagamentos.forEach((pag: any) => {
        texto += `${String(pag.forma || 'Outros').toUpperCase()} R$ ${formatarValor(pag.valor)}\n`;
      });

      // Protocolo e chave
      texto += `${sep}\n`;
      if (cupomFiscal.protocolo) texto += `Prot: ${cupomFiscal.protocolo}\n`;
      if (cupomFiscal.chave) {
        quebrarTextoEmLinhas(`Chave: ${formatarChave(cupomFiscal.chave)}`, largura).forEach((l: string) => { texto += `${l}\n`; });
      }
      texto += `${sep}\n`;

      // Montar ESC/POS
      const ESC = 0x1B;
      const LF = 0x0A;
      const CORTA_PAPEL = [ESC, 0x69];
      const NEGRITO_ON = [ESC, 0x45, 0x01];
      const NEGRITO_OFF = [ESC, 0x45, 0x00];
      const RESET = [0x1B, 0x40];
      const CENTRALIZAR = [0x1B, 0x61, 0x01];
      const ESQUERDA = [0x1B, 0x61, 0x00];

      // QR Code via QRCode.toCanvas → ESC/POS GS v 0 raster bitmap
      const qrContent = cupomFiscal.qrCodeUrl || cupomFiscal.chave || '';
      console.log("qrContent", qrContent);
      let qrCodeBytes: number[] = [];
      if (!imprimir58mm) {
        if (qrContent) {
          try {
            const qrSize = imprimir58mm ? 260 : 300;
            const qrCanvas = document.createElement('canvas');
            await QRCode.toCanvas(qrCanvas, qrContent, {
              width: qrSize,
              margin: 1,
              color: { dark: '#000000', light: '#ffffff' }
            });
            const ctx = qrCanvas.getContext('2d');
            if (ctx) {
              const { width, height } = qrCanvas;
              const imageData = ctx.getImageData(0, 0, width, height);
              const pixels = imageData.data; // RGBA
              const bytesPerRow = Math.ceil(width / 8);

              // ESC a 01: Alinhamento centralizado
              qrCodeBytes.push(0x1B, 0x61, 0x01);

              // ESC/POS GS v 0: raster bit image
              qrCodeBytes.push(0x1D, 0x76, 0x30, 0x00);
              qrCodeBytes.push(bytesPerRow & 0xFF, (bytesPerRow >> 8) & 0xFF);
              qrCodeBytes.push(height & 0xFF, (height >> 8) & 0xFF);
              for (let y = 0; y < height; y++) {
                for (let bx = 0; bx < bytesPerRow; bx++) {
                  let byte = 0;
                  for (let bit = 0; bit < 8; bit++) {
                    const px = bx * 8 + bit;
                    if (px < width) {
                      const idx = (y * width + px) * 4;
                      if (pixels[idx] < 128) byte |= (0x80 >> bit);
                    }
                  }
                  qrCodeBytes.push(byte);
                }
              }
              // ESC a 00: Voltar alinhamento à esquerda
              qrCodeBytes.push(0x1B, 0x61, 0x00);
            }
          } catch (e) {
            console.error('Erro ao gerar QR code canvas:', e);
          }
        }
      }

      // Texto final após o QR code
      const consultaUrl = cupomFiscal.urlChave || 'www.nfce.fazenda.sp.gov.br';
      const textoFinal = `Consulte pela chave em:\n${consultaUrl}\n`;
      const consultaBytes = removerAcentosECedilha(textoFinal).split("").map((c: string) => c.charCodeAt(0));

      const dadosImpressao: any = [
        ...RESET,

        LF,
        ...NEGRITO_ON,
        ...removerAcentosECedilha(texto).split("").map((c: string) => c.charCodeAt(0)),
        ...NEGRITO_OFF,
        LF,
        ...CENTRALIZAR,
        ...qrCodeBytes,
        LF,
        ...consultaBytes,
        ...ESQUERDA,
        LF, LF, LF, LF, LF,
        ...CORTA_PAPEL
      ];

      return new Uint8Array(dadosImpressao);
    } catch (error) {
      console.error('Erro ao gerar cupom fiscal ESC/POS:', error);
      return null;
    }
  }

  async function imprimirFiscal(cupomFiscal: any) {
    if (!cupomFiscal) return;

    const quantidadeImpressoes = dadosEmpresa.impressaoDuasVias ? 2 : 1;
    const comandosEscPos = await gerarEscPosFiscal(cupomFiscal, (dadosEmpresa.impressoraLargura == "58" ? true : false));

    if (comandosEscPos) {
      const mobile = !isPlatform('mobileweb') && isPlatform('mobile');
      let tipo: 'ble' | 'spp' | 'rede' | 'local' | null = null;
      let config: any = {};

      if (impressoraRedeHabilitar && mobile) {
        tipo = 'rede';
        config = { ip: dadosEmpresa.impressoraRedeIp, porta: dadosEmpresa.impressoraRedePorta };
      } else if (impressoraLocalHabilitar && !mobile) {
        tipo = 'local';
        config = { printerName: window.localStorage.getItem("impressoraLocalName") || "" };
      } else if (impressoraBluetoothHabilitar && mobile) {
        tipo = 'ble';
        config = { deviceId: window.localStorage.getItem("impressoraBluetoothDeviceId") };
      } else if (impressoraBluetoothSPPHabilitar && isPlatform('android') && mobile) {
        tipo = 'spp';
        config = { address: window.localStorage.getItem("impressoraBluetoothSPPAddress") };
      }

      if (tipo) {
        const adicionado = adicionarImpressaoNaFila(criarJobImpressao({
          comandosEscPos,
          dados: cupomFiscal,
          impressoraConfig: config,
          tipo,
          quantidadeVias: quantidadeImpressoes,
          origem: 'ComandasProdutosMemory:imprimirFiscal'
        }));

        if (adicionado) {
          console.log('📋 [COMANDA] Cupom fiscal adicionado na fila');
          return;
        }
      }
    }

    mostrarAlerta({
      header: 'Cupom Fiscal',
      message: 'NFC-e autorizada! Deseja visualizar o cupom fiscal?',
      buttons: [
        { text: 'Não', role: 'cancel' },
        { text: 'Visualizar', handler: () => { window.open(cupomFiscal.cupomFiscalUrl, '_blank'); } }
      ]
    })
  }

  async function imprimir() {

    const quantidadeImpressoes = dadosEmpresa.impressaoDuasVias ? 2 : 1;

    // === NOVO: SISTEMA DE FILA DE IMPRESSÃO ===
    const comandosEscPos = gerarEscPos(dadosComandas, (dadosEmpresa.impressoraLargura == "58" ? true : false), dadosEmpresa.tamanhoFonte === "grande");
    if (comandosEscPos) {
      const mobile = !isPlatform('mobileweb') && isPlatform('mobile');

      let tipo: 'ble' | 'spp' | 'rede' | 'local' | null = null;
      let config: any = {};

      if (impressoraRedeHabilitar && mobile) {
        tipo = 'rede';
        config = { ip: dadosEmpresa.impressoraRedeIp, porta: dadosEmpresa.impressoraRedePorta };
      } else if (impressoraLocalHabilitar && !mobile) {
        tipo = 'local';
        config = { printerName: window.localStorage.getItem("impressoraLocalName") || "" };
      } else if (impressoraBluetoothHabilitar && mobile) {
        tipo = 'ble';
        config = { deviceId: window.localStorage.getItem("impressoraBluetoothDeviceId") };
      } else if (impressoraBluetoothSPPHabilitar && isPlatform('android') && mobile) {
        tipo = 'spp';
        config = { address: window.localStorage.getItem("impressoraBluetoothSPPAddress") };
      }

      if (tipo) {
        const adicionado = adicionarImpressaoNaFila(criarJobImpressao({
          comandosEscPos,
          dados: dadosComandas,
          impressoraConfig: config,
          tipo,
          quantidadeVias: quantidadeImpressoes,
          origem: 'ComandasProdutosMemory:imprimir'
        }));

        if (adicionado) {
          console.log('📋 [COMANDA] Cupom adicionado na fila');
          return; // Sucesso - não executar código legado
        }
      }
    }
    // === FIM DO SISTEMA DE FILA ===

    return new Promise<void>((resolve, reject) => {
      gerarCupomMesa(params.id)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });

  }

  function converterParaString(dadosImpressao: any) {
    return String.fromCharCode(...dadosImpressao.filter((byte: any) => byte <= 0xFF)); // Filtrando valores válidos
  }

  async function enviarImpressao(printer: any, data: any) {

    const url = "http://localhost:9100/print";

    // Montando o corpo da requisição no formato necessário
    var raw = JSON.stringify({
      "printer": printer,
      "data": data,  // Dados no formato correto (com códigos ESC/POS)
    });

    try {
      // Configurações da requisição
      const requestOptions: any = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: 'follow',
      };

      // Envia a requisição utilizando fetch
      const resp = await fetch(url, requestOptions);

      // Aguardar a resposta como texto
      const result = await resp.text();

      if (result) {
        console.log("Impressão enviada com sucesso:", result);
      } else {
        console.error("Erro: Nenhuma resposta recebida.");
      }
    } catch (error) {
      console.error("Erro ao enviar dados para a impressora:", error);
    }
  }

  async function gerarCupomMesa(projetoid: any) {
    return new Promise(async (resolve, reject) => {
      var token: string = "";
      var tkn = localStorage.getItem("token");
      if (typeof tkn === "string") {
        token = tkn;
      }
      console.log("projetoid", projetoid);

      let montaUrl = mesaGerarCupom.url.replaceAll("{id}", projetoid.replaceAll(/#/g, "%23"));

      try {
        const resp = await fetch(montaUrl, {
          method: mesaGerarCupom.method,
          headers: [["token", token]],
          credentials: "include",
        });

        const result = await resp.json();
        if (result) {
          // console.log("result", result);

          mostrarAlerta({
            backdropDismiss: false,
            header: "Gerar Cupom",
            message: "<strong>Cupom</strong> foi gerado com sucesso.",
            buttons: [
              {
                text: "Cancelar",
                role: "cancel",
              },
              {
                text: "Visualizar",
                cssClass: "primary",
                handler: () => {
                  window.open(result, "_blank");
                },
              },
            ],
            onDidDismiss: (e) => console.log("did dismiss"),
          });
          resolve(result); // Resolve a Promise se a impressão for bem-sucedida
        }
      } catch (error: any) {
        setTextToast(error.message);
        setShowToast(true);
        reject(error); // Rejeita a Promise em caso de erro
      }
    });
  }

  async function imprimirParcialEmImpressora(projeto: any, impressora: string) {
    console.log(`*********************impressao na impressora: ${impressora}`);

    // Busca a configuração da impressora nas impressoras adicionais pelo nome genérico
    // impressora = "Impressora 2", "Impressora 3", etc
    const impressoraConfig = dadosEmpresa?.impressorasAdicionais?.find((imp: any) =>
      imp.nome === impressora
    );

    console.log('Configuração da impressora encontrada:', impressoraConfig);

    // === NOVO: SISTEMA DE FILA DE IMPRESSÃO COM ESTRUTURA ANINHADA ===
    const comandosEscPos = gerarEscPosParcial(projeto, (dadosEmpresa.impressoraLargura == "58" ? true : false), dadosEmpresa.tamanhoFonte === "grande");
    if (comandosEscPos) {
      const mobile = !isPlatform('mobileweb') && isPlatform('mobile');

      let tipo: 'ble' | 'spp' | 'rede' | 'local' | null = null;
      let config: any = {};

      // Se encontrou impressora adicional configurada (estrutura aninhada)
      if (impressoraConfig && impressoraConfig.conexoes && Array.isArray(impressoraConfig.conexoes)) {
        console.log('Usando impressora adicional configurada (estrutura aninhada)');
        console.log('Conexões disponíveis:', impressoraConfig.conexoes);

        // Procura a primeira conexão válida para a plataforma atual
        for (const conexao of impressoraConfig.conexoes) {
          console.log('Verificando conexão:', conexao.tipo);

          if (mobile) {
            // Mobile: verifica tipos mobile (rede, ble, spp)
            if (conexao.tipo === 'rede' && conexao.redeIp && conexao.redePorta) {
              tipo = 'rede';
              config = {
                ip: conexao.redeIp,
                porta: parseInt(conexao.redePorta || '9100', 10)
              };
              console.log('✅ Usando conexão REDE:', config);
              break;
            } else if (conexao.tipo === 'ble' && conexao.bluetoothDeviceId) {
              tipo = 'ble';
              config = { deviceId: conexao.bluetoothDeviceId };
              console.log('✅ Usando conexão BLE:', config);
              break;
            } else if (conexao.tipo === 'spp' && isPlatform('android') && conexao.bluetoothSPPAddress) {
              tipo = 'spp';
              config = { address: conexao.bluetoothSPPAddress };
              console.log('✅ Usando conexão SPP:', config);
              break;
            }
          } else {
            // Desktop: verifica tipo local
            if (conexao.tipo === 'local' && conexao.localName) {
              tipo = 'local';
              config = { printerName: conexao.localName };
              console.log('✅ Usando conexão LOCAL:', config);
              break;
            }
          }
        }

        if (!tipo) {
          console.log('⚠️ Nenhuma conexão válida encontrada para a plataforma atual nesta impressora');
        }
      }

      // Fallback para impressora principal se não configurou ou não encontrou tipo
      if (!tipo) {
        console.log('Impressora adicional não encontrada ou não configurada, usando impressora principal como fallback');

        if (impressoraRedeHabilitar && mobile) {
          tipo = 'rede';
          config = { ip: dadosEmpresa.impressoraRedeIp, porta: dadosEmpresa.impressoraRedePorta };
        } else if (impressoraLocalHabilitar && !mobile) {
          tipo = 'local';
          config = { printerName: window.localStorage.getItem("impressoraLocalName") || "" };
        } else if (impressoraBluetoothHabilitar && mobile) {
          tipo = 'ble';
          config = { deviceId: window.localStorage.getItem("impressoraBluetoothDeviceId") };
        } else if (impressoraBluetoothSPPHabilitar && isPlatform('android') && mobile) {
          tipo = 'spp';
          config = { address: window.localStorage.getItem("impressoraBluetoothSPPAddress") };
        }
      }

      if (tipo) {
        const adicionado = adicionarImpressaoNaFila(criarJobImpressao({
          comandosEscPos,
          dados: projeto,
          impressoraConfig: config,
          tipo,
          quantidadeVias: 1,
          origem: `ComandasProdutosMemory:imprimirParcial(${impressora})`
        }));

        if (adicionado) {
          console.log(`📋 [COMANDA-PARCIAL] Cupom adicionado na fila para ${impressora} via ${tipo}`);
          return; // Sucesso - não executar código legado
        }
      } else {
        console.log('❌ Nenhuma impressora configurada para a plataforma atual.');
        setTextToast(`Impressora ${impressora} não configurada para esta plataforma.`);
        setShowToast(true);
      }
    }
    // === FIM DO SISTEMA DE FILA ===

    // // Se não encontrou nas adicionais, usa a impressora principal como fallback
    // if (!impressoraConfig) {
    //   console.log('Impressora não encontrada nas adicionais, usando impressora principal como fallback');

    //   // REDE - Impressora principal (mobile)
    //   if (dadosEmpresa.impressoraRedeHabilitar && (!isPlatform('mobileweb') && isPlatform('mobile'))) {
    //     const ipImpressora = dadosEmpresa.impressoraRedeIp;
    //     const portaImpressora = dadosEmpresa.impressoraRedePorta;

    //     const conectarEEnviar = () => {
    //       window.chrome.sockets.tcp.create({}, (createInfo) => {
    //         const socketId = createInfo.socketId;
    //         const timeoutId = setTimeout(() => {
    //           setTextToast("Erro ao conectar.");
    //           setShowToast(true);
    //           window.chrome.sockets.tcp.close(socketId);
    //         }, 3000);

    //         window.chrome.sockets.tcp.connect(socketId, ipImpressora, portaImpressora, (result) => {
    //           if (result === 0) {
    //             clearTimeout(timeoutId);
    //             console.log('Conexão bem-sucedida! Enviando dados...');
    //             const comandosEscPos = gerarEscPosParcial(projeto);
    //             if (comandosEscPos) {
    //               window.chrome.sockets.tcp.send(socketId, comandosEscPos.buffer, (sendInfo) => {
    //                 console.log('Comando enviado com sucesso:', sendInfo);
    //                 window.chrome.sockets.tcp.close(socketId);
    //               });
    //             } else {
    //               console.error('Erro ao gerar ESC/POS');
    //             }
    //           } else {
    //             clearTimeout(timeoutId);
    //             console.error(`Erro ao conectar à impressora. Verifique a conexão.`);
    //             setTextToast("Erro ao conectar.");
    //             setShowToast(true);
    //             window.chrome.sockets.tcp.close(socketId);
    //           }
    //         });
    //       });
    //     };
    //     conectarEEnviar();
    //     return;
    //   }

    //   // LOCAL - Impressora principal (browser)
    //   else if (impressoraLocalHabilitar && !(!isPlatform('mobileweb') && isPlatform('mobile'))) {
    //     console.log("*********************impressao browser pela rede");
    //     const conectarEEnviar = () => {
    //       console.log('Conexão bem-sucedida! Enviando dados...');
    //       const comandosEscPos: any = gerarEscPosParcial(projeto);
    //       if (comandosEscPos) {
    //         const resultadoString = converterParaString(comandosEscPos);
    //         const printerName = window.localStorage.getItem("impressoraLocalName") || "";
    //         enviarImpressao(printerName, resultadoString);
    //       } else {
    //         console.error('Erro ao gerar ESC/POS');
    //       }
    //     };
    //     conectarEEnviar();
    //     return;
    //   }

    //   // BLUETOOTH - Impressora principal (mobile)
    //   else if (impressoraBluetoothHabilitar && (!isPlatform('mobileweb') && isPlatform('mobile'))) {
    //     const comandosEscPos = gerarEscPosParcial(projeto, true);
    //     if (comandosEscPos) {
    //       const PRINT_SERVICE_UUID = "000018f0-0000-1000-8000-00805f9b34fb";
    //       const PRINT_CHARACTERISTIC_UUID = "00002af1-0000-1000-8000-00805f9b34fb";
    //       const chunkSize = 20;
    //       const buffer = comandosEscPos.buffer;
    //       const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    //       try {
    //         for (let i = 0; i < buffer.byteLength; i += chunkSize) {
    //           const chunk = new DataView(buffer.slice(i, Math.min(i + chunkSize, buffer.byteLength)));
    //           await BleClient.write(
    //             window.localStorage.getItem("impressoraBluetoothDeviceId") || "",
    //             PRINT_SERVICE_UUID,
    //             PRINT_CHARACTERISTIC_UUID,
    //             chunk
    //           );
    //           await delay(50);
    //         }
    //         setTextToast("Impressão realizada com sucesso!");
    //         setShowToast(true);
    //       } catch (error) {
    //         console.error("Erro durante a impressão:", error);
    //         setTextToast("Erro ao realizar a impressão.");
    //         setShowToast(true);
    //       }
    //     } else {
    //       console.error('Erro ao gerar ESC/POS');
    //     }
    //     return;
    //   }

    //   console.log('Nenhuma impressora configurada.');
    //   return;
    // }

    // // Impressão LOCAL (browser/desktop) - Impressora adicional
    // if (impressoraConfig.tipo === 'local' && !(!isPlatform('mobileweb') && isPlatform('mobile'))) {
    //   console.log('Tipo: LOCAL (browser) - Impressora adicional');
    //   console.log('Enviando para impressora local:', impressoraConfig.localName);
    //   const comandosEscPos: any = gerarEscPosParcial(projeto);
    //   if (comandosEscPos) {
    //     const resultadoString = converterParaString(comandosEscPos);
    //     enviarImpressao(impressoraConfig.localName, resultadoString);
    //   } else {
    //     console.error('Erro ao gerar ESC/POS');
    //   }
    // }

    // // Impressão REDE (mobile) - Impressora adicional
    // else if (impressoraConfig.tipo === 'rede' && (!isPlatform('mobileweb') && isPlatform('mobile'))) {
    //   console.log('Tipo: REDE (mobile) - Impressora adicional');
    //   console.log('IP:', impressoraConfig.redeIp, 'Porta:', impressoraConfig.redePorta);

    //   if (!impressoraConfig.redeIp || !impressoraConfig.redePorta) {
    //     console.error('IP ou Porta não configurados para impressora de rede');
    //     setTextToast("Impressora de rede não configurada corretamente.");
    //     setShowToast(true);
    //     return;
    //   }

    //   const conectarEEnviar = () => {
    //     window.chrome.sockets.tcp.create({}, (createInfo) => {
    //       const socketId = createInfo.socketId;
    //       const timeoutId = setTimeout(() => {
    //         setTextToast("Erro ao conectar na impressora de rede.");
    //         setShowToast(true);
    //         window.chrome.sockets.tcp.close(socketId);
    //       }, 3000);

    //       window.chrome.sockets.tcp.connect(
    //         socketId,
    //         impressoraConfig.redeIp,
    //         parseInt(impressoraConfig.redePorta || '9100', 10),
    //         (result) => {
    //           if (result === 0) {
    //             clearTimeout(timeoutId);
    //             console.log('Conexão de rede bem-sucedida! Enviando dados...');
    //             const comandosEscPos = gerarEscPosParcial(projeto);
    //             if (comandosEscPos) {
    //               window.chrome.sockets.tcp.send(socketId, comandosEscPos.buffer, (sendInfo) => {
    //                 console.log('Comando enviado com sucesso:', sendInfo);
    //                 window.chrome.sockets.tcp.close(socketId);
    //               });
    //             } else {
    //               console.error('Erro ao gerar ESC/POS');
    //             }
    //           } else {
    //             clearTimeout(timeoutId);
    //             console.error('Erro ao conectar à impressora de rede.');
    //             setTextToast("Erro ao conectar na impressora de rede.");
    //             setShowToast(true);
    //             window.chrome.sockets.tcp.close(socketId);
    //           }
    //         }
    //       );
    //     });
    //   };
    //   conectarEEnviar();
    // }

    // // Impressão BLUETOOTH (mobile) - Impressora adicional
    // else if (impressoraConfig.tipo === 'bluetooth' && (!isPlatform('mobileweb') && isPlatform('mobile'))) {
    //   console.log('Tipo: BLUETOOTH (mobile) - Impressora adicional');
    //   console.log('Bluetooth Device ID:', impressoraConfig.bluetoothDeviceId);

    //   if (!impressoraConfig.bluetoothDeviceId) {
    //     console.error('bluetoothDeviceId não configurado para impressora Bluetooth');
    //     setTextToast("Impressora Bluetooth não configurada corretamente.");
    //     setShowToast(true);
    //     return;
    //   }

    //   const comandosEscPos = gerarEscPosParcial(projeto, (dadosEmpresa.impressoraLargura == "58" ? true : false));
    //   if (comandosEscPos) {
    //     const PRINT_SERVICE_UUID = "000018f0-0000-1000-8000-00805f9b34fb";
    //     const PRINT_CHARACTERISTIC_UUID = "00002af1-0000-1000-8000-00805f9b34fb";
    //     const chunkSize = 20;
    //     const buffer = comandosEscPos.buffer;
    //     const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    //     try {
    //       for (let i = 0; i < buffer.byteLength; i += chunkSize) {
    //         const chunk = new DataView(buffer.slice(i, Math.min(i + chunkSize, buffer.byteLength)));
    //         await BleClient.write(
    //           impressoraConfig.bluetoothDeviceId,
    //           PRINT_SERVICE_UUID,
    //           PRINT_CHARACTERISTIC_UUID,
    //           chunk
    //         );
    //         await delay(50);
    //       }
    //       console.log('Impressão Bluetooth realizada com sucesso!');
    //       setTextToast("Impressão Bluetooth realizada com sucesso!");
    //       setShowToast(true);
    //     } catch (error) {
    //       console.error("Erro durante a impressão Bluetooth:", error);
    //       setTextToast("Erro ao realizar a impressão Bluetooth.");
    //       setShowToast(true);
    //     }
    //   } else {
    //     console.error('Erro ao gerar ESC/POS');
    //   }
    // }
  }

  async function gerarCupomParcial(projeto: any) {
    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }
    // console.log("projetoid", projetoid);

    const resp = await fetch(projetoGerarCupomParcial.url.replaceAll("{id}", params.id.replaceAll(/#/g, "%23")),
      {
        method: projetoGerarCupomParcial.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    const result = await resp.json();
    if (result) {


      // gerarEscPos(projeto);
      // return;

      // Verifica se há múltiplas impressoras configuradas
      if (dadosEmpresa?.multiImpressao && dadosEmpresa.multiImpressao > 1) {
        // Agrupa produtos por impressora selecionada
        const produtosPorImpressora: any = {};

        console.log('=== INÍCIO DEBUG MULTI-IMPRESSÃO ===');
        console.log('Produtos do projeto:', projeto.produtos?.length, 'itens');

        projeto.produtos?.filter((prod: any) => (!prod.impresso)).forEach((produto: any, idx: any) => {
          console.log(`\n--- Produto ${idx + 1} ---`);
          console.log('Produto do pedido - indice:', produto.indice, 'impressoraSelecionada:', produto.impressoraSelecionada);

          // Usa a impressora que já vem no produto, com fallback para localStorage
          const impressora = produto.impressoraSelecionada;

          console.log(`Impressora selecionada: "${impressora}"`);

          if (!produtosPorImpressora[impressora]) {
            produtosPorImpressora[impressora] = [];
          }
          produtosPorImpressora[impressora].push(produto);
        });

        console.log('\n=== AGRUPAMENTO FINAL ===');
        console.log('Produtos agrupados por impressora:', produtosPorImpressora);

        // Imprime em cada impressora separadamente
        for (const impressora in produtosPorImpressora) {
          const projetoParaImpressora = {
            ...projeto,
            produtos: produtosPorImpressora[impressora]
          };

          console.log(`\n>>> Enviando para impressora: "${impressora}"`, projetoParaImpressora);
          await imprimirParcialEmImpressora(projetoParaImpressora, impressora);
        }

        console.log('=== FIM DEBUG MULTI-IMPRESSÃO ===\n');
        return;
      }

      // === NOVO: SISTEMA DE FILA DE IMPRESSÃO ===
      const comandosEscPos = gerarEscPosParcial(projeto, (dadosEmpresa.impressoraLargura == "58" ? true : false), dadosEmpresa.tamanhoFonte === "grande");
      if (comandosEscPos) {
        const mobile = !isPlatform('mobileweb') && isPlatform('mobile');

        let tipo: 'ble' | 'spp' | 'rede' | 'local' | null = null;
        let config: any = {};

        if (impressoraRedeHabilitar && mobile) {
          tipo = 'rede';
          config = { ip: dadosEmpresa.impressoraRedeIp, porta: dadosEmpresa.impressoraRedePorta };
        } else if (impressoraLocalHabilitar && !mobile) {
          tipo = 'local';
          config = { printerName: window.localStorage.getItem("impressoraLocalName") || "" };
        } else if (impressoraBluetoothHabilitar && mobile) {
          tipo = 'ble';
          config = { deviceId: window.localStorage.getItem("impressoraBluetoothDeviceId") };
        } else if (impressoraBluetoothSPPHabilitar && isPlatform('android') && mobile) {
          tipo = 'spp';
          config = { address: window.localStorage.getItem("impressoraBluetoothSPPAddress") };
        }

        if (tipo) {
          const adicionado = adicionarImpressaoNaFila(criarJobImpressao({
            comandosEscPos,
            dados: projeto,
            impressoraConfig: config,
            tipo,
            quantidadeVias: 1,
            origem: 'ComandasProdutosMemory:gerarCupomParcial'
          }));

          if (adicionado) {
            console.log('📋 [COMANDA-PARCIAL-GERAL] Cupom parcial adicionado na fila');
            return; // Sucesso - não executar código legado
          }
        }
      }
      // === FIM DO SISTEMA DE FILA ===

      // if (dadosEmpresa.impressoraRedeHabilitar && (!isPlatform('mobileweb') && isPlatform('mobile'))) {

      //   const ipImpressora = dadosEmpresa.impressoraRedeIp;
      //   const portaImpressora = dadosEmpresa.impressoraRedePorta;

      //   const conectarEEnviar = () => {
      //     // Cria o socket TCP
      //     window.chrome.sockets.tcp.create({}, (createInfo) => {
      //       const socketId = createInfo.socketId;

      //       // Define o timeout para mostrar a mensagem de erro após 3 segundos
      //       const timeoutId = setTimeout(() => {
      //         setTextToast("Erro ao conectar.");
      //         setShowToast(true);
      //         window.chrome.sockets.tcp.close(socketId);
      //       }, 3000); // 3 segundos

      //       // Tenta conectar ao IP e porta especificados
      //       window.chrome.sockets.tcp.connect(socketId, ipImpressora, portaImpressora, (result) => {
      //         if (result === 0) {
      //           // Conexão bem-sucedida, cancela o timeout
      //           clearTimeout(timeoutId);

      //           console.log('Conexão bem-sucedida! Enviando dados...');

      //           const comandosEscPos = gerarEscPosParcial(projeto);
      //           if (comandosEscPos) {
      //             window.chrome.sockets.tcp.send(socketId, comandosEscPos.buffer, (sendInfo) => {
      //               console.log('Comando enviado com sucesso:', sendInfo);
      //               window.chrome.sockets.tcp.close(socketId);
      //             });
      //           } else {
      //             console.error('Erro ao gerar ESC/POS');
      //           }
      //         } else {
      //           // Conexão falhou, cancela o timeout e mostra mensagem de erro
      //           clearTimeout(timeoutId);
      //           console.error(`Erro ao conectar à impressora. Verifique a conexão.`);
      //           setTextToast("Erro ao conectar.");
      //           setShowToast(true);
      //           window.chrome.sockets.tcp.close(socketId);
      //         }
      //       });
      //     });
      //   };


      //   // Chame a função com o URL do HTML que você deseja imprimir
      //   conectarEEnviar();


      // }
      // else if (impressoraLocalHabilitar && !(!isPlatform('mobileweb') && isPlatform('mobile'))) {

      //   console.log("*********************impressao browser pela rede");
      //   const ipImpressora = dadosEmpresa.impressoraRedeIp;
      //   const portaImpressora = dadosEmpresa.impressoraRedePorta;



      //   const conectarEEnviar = () => {
      //     // Cria o socket TCP


      //     console.log('Conexão bem-sucedida! Enviando dados...');

      //     const comandosEscPos: any = gerarEscPosParcial(projeto);

      //     if (comandosEscPos) {
      //       // Exemplo de uso
      //       const resultadoString = converterParaString(comandosEscPos);
      //       // const resultadoString = arrayToEscapedString(comandosEscPos);
      //       //console.log(resultadoString);




      //       const printerName = window.localStorage.getItem("impressoraLocalName") || "";

      //       enviarImpressao(printerName, resultadoString);




      //     } else {
      //       console.error('Erro ao gerar ESC/POS');
      //     }

      //   };


      //   // Chame a função com o URL do HTML que você deseja imprimir
      //   conectarEEnviar();


      // }
      // else if (impressoraBluetoothHabilitar && (!isPlatform('mobileweb') && isPlatform('mobile'))) {
      //   const comandosEscPos = gerarEscPosParcial(projeto, true);
      //   if (comandosEscPos) {
      //     const PRINT_SERVICE_UUID = "000018f0-0000-1000-8000-00805f9b34fb";
      //     const PRINT_CHARACTERISTIC_UUID = "00002af1-0000-1000-8000-00805f9b34fb";
      //     // Fragmentar os dados em pacotes menores
      //     const chunkSize = 20; // Tamanho máximo permitido por pacote BLE
      //     const buffer = comandosEscPos.buffer;

      //     const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

      //     try {
      //       const impressoraBluetoothDeviceId = window.localStorage.getItem("impressoraBluetoothDeviceId");

      //       if (!impressoraBluetoothDeviceId) {
      //         setTextToast("Nenhum dispositivo BLE configurado.");
      //         setShowToast(true);
      //         return;
      //       }

      //       // Verifica se já está conectado
      //       let isConnected = false;
      //       try {
      //         const connectedDevices = await BleClient.getConnectedDevices([]);
      //         isConnected = connectedDevices.some(device => device.deviceId === impressoraBluetoothDeviceId);
      //         console.log('Estado inicial da conexão BLE:', isConnected ? 'CONECTADO' : 'DESCONECTADO');
      //       } catch (checkError) {
      //         console.log('Não conectado (verificação falhou):', checkError);
      //         isConnected = false;
      //       }

      //       if (!isConnected) {
      //         // Tenta conectar ao dispositivo
      //         console.log('Iniciando conexão BLE com:', impressoraBluetoothDeviceId);
      //         await BleClient.connect(impressoraBluetoothDeviceId);
      //         console.log('Conexão BLE estabelecida!');

      //         // Aguarda estabilização
      //         await delay(1000);
      //       } else {
      //         console.log('BLE já conectado, reutilizando conexão existente');
      //       }

      //       // Loop para enviar os dados em pacotes
      //       for (let i = 0; i < buffer.byteLength; i += chunkSize) {
      //         const chunk = new DataView(buffer.slice(i, Math.min(i + chunkSize, buffer.byteLength)));
      //         await BleClient.write(
      //           impressoraBluetoothDeviceId || "",
      //           PRINT_SERVICE_UUID,
      //           PRINT_CHARACTERISTIC_UUID,
      //           chunk
      //         );
      //         await delay(50); // Atraso de 50ms entre os envios
      //       }

      //       setTextToast("Impressão realizada com sucesso!");
      //       setShowToast(true);

      //     } catch (error: any) {
      //       console.error("Erro durante a impressão BLE:", error);
      //       setTextToast(error.message || "Erro ao realizar a impressão BLE.");
      //       setShowToast(true);

      //       // NÃO desconecta em caso de erro - mantém conexão para próximas tentativas
      //     }
      //   } else {
      //     console.error('Erro ao gerar ESC/POS');
      //   }
      // }
      // else if (impressoraBluetoothSPPHabilitar && isPlatform('android') && (!isPlatform('mobileweb') && isPlatform('mobile'))) {
      //   const comandosEscPos = gerarEscPosParcial(projeto, true);
      //   if (comandosEscPos) {
      //     try {
      //       const impressoraBluetoothSPPAddress = window.localStorage.getItem("impressoraBluetoothSPPAddress");

      //       if (!impressoraBluetoothSPPAddress) {
      //         setTextToast("Nenhum dispositivo SPP configurado.");
      //         setShowToast(true);
      //         return;
      //       }

      //       // Verifica se já está conectado
      //       let isConnected = false;
      //       try {
      //         isConnected = await BluetoothSerial.isConnected();
      //         console.log('Estado inicial da conexão SPP:', isConnected ? 'CONECTADO' : 'DESCONECTADO');
      //       } catch (checkError) {
      //         console.log('Não conectado (isConnected falhou):', checkError);
      //         isConnected = false;
      //       }

      //       if (!isConnected) {
      //         // Conecta ao dispositivo
      //         console.log('Iniciando conexão SPP com:', impressoraBluetoothSPPAddress);

      //         await new Promise<void>((resolve, reject) => {
      //           let connectionTimeout: any;

      //           // Subscribe para monitorar dados
      //           BluetoothSerial.subscribe('\n').subscribe(
      //             (data: any) => {
      //               console.log('Subscribe SPP recebeu dados:', data);
      //             },
      //             (error: any) => {
      //               console.log('Erro no subscribe SPP:', error);
      //             }
      //           );

      //           // Timeout de 10 segundos
      //           connectionTimeout = setTimeout(() => {
      //             BluetoothSerial.disconnect();
      //             reject(new Error('Timeout: não foi possível conectar à impressora em 10 segundos.'));
      //           }, 10000);

      //           // Conecta
      //           BluetoothSerial.connect(impressoraBluetoothSPPAddress).subscribe(
      //             async () => {
      //               clearTimeout(connectionTimeout);
      //               console.log('Callback de conexão SPP executado!');

      //               // Aguarda estabilização
      //               await new Promise(r => setTimeout(r, 1500));

      //               try {
      //                 // Verifica conexão
      //                 const isNowConnected = await BluetoothSerial.isConnected();
      //                 console.log('Estado após conectar SPP:', isNowConnected ? 'CONECTADO' : 'DESCONECTADO');

      //                 if (!isNowConnected) {
      //                   throw new Error('Impressora não conectou. Verifique se está ligada.');
      //                 }

      //                 resolve();
      //               } catch (err) {
      //                 reject(err);
      //               }
      //             },
      //             (error: any) => {
      //               clearTimeout(connectionTimeout);
      //               console.error('Erro ao conectar SPP:', error);
      //               reject(new Error(`Falha na conexão: ${error}`));
      //             }
      //           );
      //         });
      //       } else {
      //         console.log('SPP já conectado, reutilizando conexão existente');
      //       }

      //       // Converte Uint8Array para string (sem fragmentação)
      //       const dataString = Array.from(comandosEscPos)
      //         .map(byte => String.fromCharCode(byte))
      //         .join('');

      //       // Envia todos os dados de uma vez
      //       console.log('Enviando', comandosEscPos.length, 'bytes para a impressora SPP...');
      //       await BluetoothSerial.write(dataString);
      //       console.log('Dados SPP enviados com sucesso!');

      //       setTextToast("Impressão realizada com sucesso!");
      //       setShowToast(true);

      //     } catch (error: any) {
      //       console.error("Erro durante a impressão SPP:", error);
      //       setTextToast(error.message || "Erro ao realizar a impressão SPP.");
      //       setShowToast(true);

      //       // NÃO desconecta em caso de erro - mantém conexão para próximas tentativas
      //     }
      //   } else {
      //     console.error('Erro ao gerar ESC/POS');
      //   }
      // }
      // else {



      // console.log("result", result);

      mostrarAlerta({
        backdropDismiss: false,
        header: 'Imprimir',
        message: '<strong>Pedido</strong> foi gerado com sucesso.',
        buttons: [
          // {
          //   text: 'Cancelar',
          //   role: 'cancel',
          // },
          {
            text: 'Imprimir',
            cssClass: 'primary',
            handler: () => {
              window.open(result, '_blank');
            }
          }
        ],
        onDidDismiss: (e) => console.log('did dismiss'),
      })
      // }

    }

  }

  async function closeModalComandasFechar(formaPagamento: any) {
    setShowComandasFechar(false);
    // await alterar(formaPagamento, dadosComandas.taxaServico, dadosComandas.taxaEntrega, dadosComandas.desconto);
  }

  async function closeModalComandasFecharSucess() {
    setShowComandasFechar(false);
    history.goBack();
  }

  async function closeModalTaxaServico() {
    setShowModalTaxaServico(false);
  }

  async function closeModalTaxaServicoSucess(taxaServico: any) {
    setShowModalTaxaServico(false);
    await alterar(dadosComandas.formaPagamento, taxaServico, dadosComandas.taxaEntrega, dadosComandas.desconto);
  }

  async function closeModalDesconto() {
    setShowModalDesconto(false);
  }

  async function closeModalDescontoSucess(desconto: DescontoPayload) {
    setShowModalDesconto(false);
    setDescontoSelecionado(desconto);
    const descontoMonetario = converterDescontoParaValorMonetario(desconto, valorTotalProdutos);
    await alterar(dadosComandas.formaPagamento, dadosComandas.taxaServico, dadosComandas.taxaEntrega, descontoMonetario);
  }

  async function closeModalTransferirSucess(idMesa: any) {
    setShowModalTransferir(false);
    // history.push("comandas/produtos", { id: idMesa });
    history.goBack();
  }

  async function closeModalTransferir() {
    setShowModalTransferir(false);
  }

  const temProdutosNovosAdicionados = (listaItemProdutos: any[]): boolean => {
    return listaItemProdutos.filter((produto: any) => !produto.salvo).length > 0;
  };

  const loadItemProdutos = () => {

    if (listaItemProdutos == undefined) return;

    if (listaItemProdutos.length === 0) {
      return (
        <>
          <IonItem lines="none">

            <IonLabel>
              <h2 style={{ "verticalAlign": "middle" }}><strong>Nenhum item cadastrado</strong></h2>
            </IonLabel>

          </IonItem>
        </>

      );
    }


    return (
      <>
        <IonGrid>

          {listaItemProdutos.map((value: any, index: any) => (
            <>


              {value.enviado ? (
                <div style={{ position: 'relative' }}>
                  <div style={{ position: 'absolute', top: '4px', right: '0px', textAlign: 'right' }}>
                    <IonChip

                      style={{
                        height: "20px",
                        backgroundColor: 'var(--ion-color-medium)',
                        color: '#fff',
                        fontWeight: 'bold',

                      }}
                    >
                      ENVIADO
                    </IonChip>
                  </div>
                </div>
              ) :
                value.salvo ? (
                  <div style={{ position: 'relative' }}>
                    <div style={{ position: 'absolute', top: '4px', right: '0px', textAlign: 'right' }}>
                      <IonChip

                        style={{
                          height: "20px",
                          backgroundColor: 'var(--ion-color-primary)',
                          color: '#fff',
                          fontWeight: 'bold',

                        }}
                      >
                        SALVO
                      </IonChip>
                    </div>
                  </div>
                ) : (
                  <div style={{ position: 'relative' }}>
                    <div style={{ position: 'absolute', top: '4px', right: '0px', textAlign: 'right' }}>
                      <IonChip

                        style={{
                          height: "20px",
                          backgroundColor: 'var(--ion-color-success)',
                          color: '#fff',
                          fontWeight: 'bold',

                        }}
                      >
                        NOVO
                      </IonChip>
                    </div>
                  </div>
                )
              }

              <IonRow style={{ borderColor: '#dddddd', borderWidth: '1px', borderBottomStyle: 'dashed' }}>


                <IonCol size="9">



                  {(value.descricao && Array.isArray(value.descricao)) ? (

                    <>
                      {(value.tipo === "pizzas") ? (
                        <div>{value.tamanho} {value.quantidadeSabores} SABORES</div>
                      ) : (
                        <div>{value.categoria}</div>
                      )}
                      {value.descricao.map((item: any, index: number) => (
                        <div key={"desc" + index}>
                          {item.categoria === "Observação" ? (
                            <div style={{ textDecoration: "underline" }}>
                              Observação: {item.descricao}
                            </div>
                          ) : (
                            <div>
                              - {item.descricao}{" "}
                              <IonLabel style={{ textAlign: "right", fontSize: "12px" }}>
                                R$ {item.valor?.toLocaleString("pt-br", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </IonLabel>
                            </div>
                          )}
                        </div>
                      ))}
                    </>

                  ) : (
                    <div key={"desc" + index}>
                      {value.descricao} (<IonLabel style={{ textAlign: "right", fontSize: "12px" }}>R$ {value.valor?.toLocaleString('pt-br', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}</IonLabel>)

                    </div>
                  )}
                </IonCol>

                <IonCol style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }} sizeXs="3" >
                  <IonLabel style={{ textAlign: "right" }}>{value.subtotal}</IonLabel>
                </IonCol>
                <IonCol sizeSm='6'>
                  <IonLabel style={{ textAlign: "right", fontSize: "12px" }} >
                    <IonChip style={{ margin: 0, padding: '5px' }} disabled={!showHabilitarEdicao && value.salvo}>
                      <IonIcon size='large' color='danger' icon={removeCircle} onClick={() => {

                        // Faz uma cópia da lista atual de produtos
                        let updatedList = [...listaItemProdutos];

                        // Acessa o item que será atualizado
                        let itemToUpdate = { ...updatedList[index] };

                        // Formata a quantidade atual
                        const quantidadeFormatada = parseFloat(
                          itemToUpdate.quantidade.toString().replace(/\./g, '').replace(/\,/g, '.')
                        );

                        if (quantidadeFormatada > 1) {
                          // Decrementa a quantidade
                          let quantidadeNova = quantidadeFormatada - 1;

                          // Formata o valor e calcula o novo valor com base na nova quantidade
                          const valorFormatado = parseFloat(
                            itemToUpdate.valor.toString().replace(/\./g, '').replace(/\,/g, '.')
                          );

                          // Atualiza a quantidade e o valor do item
                          itemToUpdate.quantidade = quantidadeNova;
                          const valorFloat = quantidadeNova * valorFormatado;

                          itemToUpdate.subtotal = valorFloat.toLocaleString('pt-br', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          });

                          // Substitui o item atualizado na lista copiada
                          updatedList[index] = itemToUpdate;

                          let totalValor = updatedList.reduce((total: any, item: any) => {
                            const itemValorNumerico = parseFloat(
                              item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
                            );
                            return total + itemValorNumerico;
                          }, 0);

                          setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }));

                          // Atualiza o estado com a nova lista
                          setListaItemProdutos(updatedList);

                        }

                      }}></IonIcon>
                      <IonLabel style={{ fontSize: '20px' }}>{value.quantidade.toLocaleString('pt-br', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                      })}</IonLabel>
                      <IonIcon size='large' color='success' icon={addCircle} onClick={() => {

                        // Faz uma cópia da lista atual de produtos
                        let updatedList = [...listaItemProdutos];

                        // Acessa o item que será atualizado
                        let itemToUpdate = { ...updatedList[index] };

                        // Formata e incrementa a quantidade
                        const quantidadeFormatada = parseFloat(
                          itemToUpdate.quantidade.toString().replace(/\./g, '').replace(/\,/g, '.')
                        );

                        let quantidadeNova = quantidadeFormatada + 1;

                        // Formata o valor e calcula o novo valor com base na nova quantidade
                        const valorFormatado = parseFloat(
                          itemToUpdate.valor.toString().replace(/\./g, '').replace(/\,/g, '.')
                        );

                        // Atualiza a quantidade e o valor do item
                        itemToUpdate.quantidade = quantidadeNova;
                        const valorFloat = quantidadeNova * valorFormatado;

                        itemToUpdate.subtotal = valorFloat.toLocaleString('pt-br', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        });

                        // Substitui o item atualizado na lista copiada
                        updatedList[index] = itemToUpdate;

                        let totalValor = updatedList.reduce((total: any, item: any) => {
                          const itemValorNumerico = parseFloat(
                            item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
                          );
                          return total + itemValorNumerico;
                        }, 0);

                        setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }));

                        // Atualiza o estado com a nova lista
                        setListaItemProdutos(updatedList);

                      }}></IonIcon>
                    </IonChip>
                  </IonLabel>
                </IonCol>
                <IonCol style={{ display: "flex", justifyContent: "flex-end" }} sizeSm='6'>
                  <IonButtons>
                    <IonButton disabled={!showHabilitarEdicao && value.salvo}
                      onClick={() => {
                        mostrarAlerta({
                          backdropDismiss: false,
                          header: 'Remover item',
                          message: 'Deseja <strong>remover</strong>?',
                          buttons: [
                            {
                              text: 'Cancelar',
                              role: 'cancel',
                            },
                            {
                              text: 'Confirmar',
                              cssClass: 'primary',
                              handler: () => {
                                deletarItemProdutos(index);
                              }
                            }
                          ],
                          onDidDismiss: (e) => console.log('did dismiss'),
                        });
                      }}
                    >
                      <IonIcon color="primary" icon={trash} />
                    </IonButton>
                  </IonButtons>
                </IonCol>

              </IonRow>
            </>
          ))}
        </IonGrid>
      </>
    );
  }

  async function validarSenha(
    senhaDigitada: string,
    senhaArmazenada: string | undefined | null,
    chaveSecreta: string
  ): Promise<boolean> {
    if (!senhaArmazenada) {
      setTextToast("Senha não configurada.");
      setShowToast(true);
      return false;
    }

    try {
      let senhaDescriptografada = '';

      try {
        senhaDescriptografada = await decryptSenhaAES(senhaArmazenada, chaveSecreta);
      } catch {
        try {
          senhaDescriptografada = atob(senhaArmazenada);
        } catch {
          senhaDescriptografada = '';
        }
      }

      if (senhaDigitada === senhaDescriptografada) {
        return true;
      } else {
        setTextToast("Senha incorreta.");
        setShowToast(true);
        return false;
      }
    } catch (error) {
      console.error("Erro ao validar a senha:", error);
      setTextToast("Erro ao validar a senha.");
      setShowToast(true);
      return false;
    }
  }

  async function decryptSenhaAES(encryptedBase64: string, chave: string): Promise<string> {
    const encoder = new TextEncoder();
    const decoder = new TextDecoder();

    const encryptedBinaryString = atob(encryptedBase64);
    const encryptedData = new Uint8Array(encryptedBinaryString.length);
    for (let i = 0; i < encryptedBinaryString.length; i++) {
      encryptedData[i] = encryptedBinaryString.charCodeAt(i);
    }

    if (encryptedData.length < 13) {
      throw new Error("Dados muito pequenos para conter IV + ciphertext");
    }

    const iv = encryptedData.slice(0, 12);
    const encryptedBytes = encryptedData.slice(12);

    const keyMaterial = await crypto.subtle.importKey(
      "raw",
      encoder.encode(chave),
      { name: "PBKDF2" },
      false,
      ["deriveKey"]
    );

    const key = await crypto.subtle.deriveKey(
      {
        name: "PBKDF2",
        salt: encoder.encode("algum-sal-fixo"),
        iterations: 100000,
        hash: "SHA-256",
      },
      keyMaterial,
      { name: "AES-GCM", length: 256 },
      false,
      ["decrypt"]
    );

    const decrypted = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      key,
      encryptedBytes
    );

    return decoder.decode(decrypted);
  }


  return (

    <IonPage className="ComandasProdutosMemory">
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => {
              if (temProdutosNovosAdicionados(listaItemProdutos)) {
                mostrarAlerta({
                  backdropDismiss: false,
                  header: 'Descartar novos itens',
                  message: "Itens novos adicionados. Deseja descartar?",

                  buttons: [{
                    text: 'Cancelar',
                    role: 'cancel'
                  },
                  {
                    text: 'Confirmar',
                    handler: async () => {
                      history.goBack();
                    }
                  }],
                  onDidDismiss: () => { console.log('did dismiss'); }
                })

              }
              else { history.goBack(); }

            }} />
          </IonButtons>
          <IonTitle>{dadosComandas?.clienteNome}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent ref={contentRef} fullscreen={false}>
        <IonGrid style={{ height: '100%', padding: "0px", margin: "0px" }} ref={contentCatalogoRef}>
          <IonRow style={{ height: '100%' }}>
            <IonCol hidden={stateShowMenu} style={{ height: '100%', padding: "0px", margin: "0px" }} sizeMd="8" size="12">
              <div style={{ height: '100%', maxHeight: '100%', overflow: 'auto' }}>
                <IonFab vertical='bottom' horizontal='end' style={{ "bottom": "20px", "right": "20px" }} className='visible-mobile'>
                  <IonFabButton onClick={() => scrollToBottom()} color='tertiary'>
                    <IonIcon icon={arrowDown}></IonIcon>
                  </IonFabButton>
                </IonFab>
                <OrdensProdutosCompor
                  // key={`catalogo-${reloadCatalogo ? 'reloading' : 'normal'}`}
                  empresa={dadosEmpresa}
                  disabled={showHabilitarEdicao}
                  adicionarItem={adicionarItem}
                  reload={reloadCatalogo}
                  onReloadComplete={() => { setReloadCatalogo(false); }}
                />
              </div>
            </IonCol>
            <IonCol hidden={stateShowCaixa} style={{ height: '100%', padding: "0px", margin: "0px" }} sizeMd="4" size="12">
              <div style={{ height: '100%', padding: '10px' }}>
                <IonFab vertical='top' horizontal='end' style={{ "top": "20px", "right": "20px" }} className='visible-mobile'>
                  <IonFabButton onClick={() => scrollToTop()} color='tertiary'>
                    <IonIcon icon={arrowUp}></IonIcon>
                  </IonFabButton>
                </IonFab>
                <IonCard style={{ margin: 0, height: '100%' }}>
                  <IonCardContent style={{ height: '100%' }}>

                    <IonGrid style={{ padding: "0px", margin: "0px" }}>

                      <IonRow style={{ borderColor: 'grey', fontSize: '25px', borderWidth: '1px', borderBottomStyle: 'solid' }}>
                        <IonCol style={{ padding: "0px", margin: "0px" }} size="12"><IonLabel><b>Lista de itens</b></IonLabel></IonCol>
                      </IonRow>

                    </IonGrid>

                    <div style={{ height: '100%', position: 'relative', overflow: 'auto' }}>
                      <div style={{
                        height: 'calc(100% - 260px)',
                        overflow: 'auto'
                      }}>
                        {loadItemProdutos()}
                      </div>
                    </div>
                    <div style={{ position: 'absolute', bottom: "10px", left: 0, right: 0, padding: '0 10px' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

                        {/* Resumo subtotal, desconto, taxa de serviço, total geral */}
                        <IonGrid style={{ padding: "4px", margin: "4px" }}>

                          <IonRow style={{ fontSize: '16px' }}>
                            <IonCol style={{ padding: "0px", margin: "0px" }} size="5"><IonLabel><b>Subtotal</b></IonLabel></IonCol>
                            <IonCol style={{ padding: "0px", margin: "0px" }} size="7"><IonLabel style={{ display: 'block', textAlign: "right" }}><b>{valorTotalProdutos ? "R$ " + valorTotalProdutos : "R$ 0,00"}</b></IonLabel></IonCol>

                          </IonRow>

                          <IonRow style={{ fontSize: '16px' }}>
                            <IonCol style={{ padding: "0px", margin: "0px" }} size="7"><IonLabel>Desconto</IonLabel></IonCol>
                            <IonCol style={{ padding: "0px", margin: "0px" }} size="5"><IonLabel style={{ display: 'block', textAlign: "right" }}>{dadosComandas.desconto ? "R$ " + dadosComandas.desconto : "R$ 0,00"}</IonLabel></IonCol>

                          </IonRow>

                          <IonRow style={{ fontSize: '16px' }}>
                            <IonCol style={{ padding: "0px", margin: "0px" }} size="7"><IonLabel>Taxa de serviço</IonLabel></IonCol>
                            <IonCol style={{ padding: "0px", margin: "0px" }} size="5"><IonLabel style={{ display: 'block', textAlign: "right" }}>{(dadosComandas.taxaServico || 0) + "%"}</IonLabel></IonCol>

                          </IonRow>

                          <IonRow style={{ fontSize: '20px' }}>
                            <IonCol style={{ padding: "0px", margin: "0px" }} size="5"><IonLabel><b>Total</b></IonLabel></IonCol>
                            <IonCol style={{ padding: "0px", margin: "0px" }} size="7"><IonLabel style={{ display: 'block', textAlign: "right" }}><b>{valorTotal ? "R$ " + valorTotal : "R$ 0,00"}</b></IonLabel></IonCol>

                          </IonRow>

                        </IonGrid>

                        {/* Botões imprimir, desconto, taxa serviço, alterar conta */}
                        <IonGrid style={{ padding: "0px", margin: "0px" }} hidden={showHabilitarEdicao || (temProdutosNovosAdicionados(listaItemProdutos))}>
                          <IonRow style={{ fontSize: '20px' }}>
                            <IonCol style={{ width: "20%", padding: "0px", margin: "0px" }}>
                              <IonButton color='success'
                                style={{ height: "46px", fontSize: "18px" }}
                                onClick={async () => {
                                  setShowLoading(true);

                                  imprimir()
                                    .then(() => {
                                      console.log("Impressão bem-sucedida");
                                    })
                                    .catch((error) => {
                                      console.log("Erro:", error.message);
                                      setTextToast(error.message);
                                      setShowToast(true);
                                    })
                                    .finally(() => {
                                      setShowLoading(false);
                                    });
                                }}
                                expand="block"
                                type="submit"
                              >
                                <IonIcon icon={printOutline}></IonIcon>
                              </IonButton>
                            </IonCol>
                            <IonCol style={{ width: "20%", padding: "0px", margin: "0px" }}>
                              <IonButton color='primary'
                                style={{ height: "46px", fontSize: "18px", fontWeight: 'bold' }}
                                onClick={async () => {
                                  setShowModalDesconto(true);

                                }}
                                expand="block"
                                type="submit"
                              >
                                <IonIcon icon={pricetagOutline}></IonIcon>
                              </IonButton>
                            </IonCol>

                            <IonCol style={{ width: "20%", padding: "0px", margin: "0px" }}>
                              <IonButton color='tertiary'
                                style={{ height: "46px", fontSize: "18px", fontWeight: 'bold' }}
                                onClick={async () => {
                                  setShowModalTaxaServico(true);

                                }}
                                expand="block"
                                type="submit"
                              >
                                %
                              </IonButton>
                            </IonCol>
                            <IonCol style={{ width: "20%", padding: "0px", margin: "0px" }}>
                              <IonButton color='warning'
                                style={{ height: "46px", fontSize: "18px" }}
                                onClick={async () => {

                                  if (dadosEmpresa.senhaMesa) {
                                    mostartAlerta({
                                      backdropDismiss: false,
                                      header: 'Transferir ' + (window.localStorage.getItem("nomeInternoMesaOuComanda") || "Mesa"),
                                      message: `
                                    <div>
                                      <p style="margin-bottom: 16px;">Senha:</p>
                                      <ion-item lines="none">
                                        <ion-input id="editableTitle"></ion-input>
                                      </ion-item>
                                    </div>
                                  `,
                                      buttons: [
                                        {
                                          text: 'Cancelar',
                                          role: 'cancel',
                                          handler: () => {

                                          },
                                        },
                                        {
                                          text: 'Ok',
                                          handler: async () => {
                                            const inputElement: any = document.querySelector('#editableTitle');
                                            const editedTitle = inputElement?.value || '';
                                            const chaveSecreta = 'b5f2bc02-83ab-4c02-b11d-462771eaa7fa';

                                            const valido = await validarSenha(editedTitle, dadosEmpresa.senhaMesa, chaveSecreta);

                                            if (valido) {
                                              setShowModalTransferir(true);
                                            }
                                            else {
                                              setTextToast("Senha incorreta.");
                                              setShowToast(true);
                                            }
                                          },
                                        },
                                      ],
                                      onDidPresent: () => {
                                        // // Define o valor no input após o alerta aparecer
                                        // const inputElement: any = document.querySelector('#editableTitle');
                                        // if (inputElement) {
                                        //   inputElement.value = value.nome;
                                        // }
                                      },
                                      onDidDismiss: () => {
                                        console.log('did dismiss');
                                      },
                                    });
                                  }
                                  else {
                                    setShowModalTransferir(true);
                                  }

                                }}
                                expand="block"
                                type="submit"
                              >
                                <IonIcon icon={swapHorizontalOutline}></IonIcon>
                              </IonButton>
                            </IonCol>
                            <IonCol style={{ width: "20%", padding: "0px", margin: "0px" }}>
                              <IonButton color='danger'
                                style={{ height: "46px", fontSize: "18px" }}
                                onClick={async () => {

                                  if (dadosEmpresa.senhaMesa) {
                                    mostartAlerta({
                                      backdropDismiss: false,
                                      header: 'Alterar ' + (window.localStorage.getItem("nomeInternoMesaOuComanda") || "Mesa"),
                                      message: `
                                    <div>
                                      <p style="margin-bottom: 16px;">Senha:</p>
                                      <ion-item lines="none">
                                        <ion-input id="editableTitle"></ion-input>
                                      </ion-item>
                                    </div>
                                  `,
                                      buttons: [
                                        {
                                          text: 'Cancelar',
                                          role: 'cancel',
                                          handler: () => {

                                          },
                                        },
                                        {
                                          text: 'Ok',
                                          handler: async () => {
                                            const inputElement: any = document.querySelector('#editableTitle');
                                            const editedTitle = inputElement?.value || '';
                                            const chaveSecreta = 'b5f2bc02-83ab-4c02-b11d-462771eaa7fa';

                                            const valido = await validarSenha(editedTitle, dadosEmpresa.senhaMesa, chaveSecreta);

                                            if (valido) {
                                              setListaAnteriorParaCancelar(listaItemProdutos);
                                              setShowHabilitarEdicao(true);
                                            }
                                            else {
                                              setTextToast("Senha incorreta.");
                                              setShowToast(true);
                                            }
                                          },
                                        },
                                      ],
                                      onDidPresent: () => {
                                        // // Define o valor no input após o alerta aparecer
                                        // const inputElement: any = document.querySelector('#editableTitle');
                                        // if (inputElement) {
                                        //   inputElement.value = value.nome;
                                        // }
                                      },
                                      onDidDismiss: () => {
                                        console.log('did dismiss');
                                      },
                                    });
                                  }
                                  else {
                                    setListaAnteriorParaCancelar(listaItemProdutos);
                                    setShowHabilitarEdicao(true);
                                  }

                                }}
                                expand="block"
                                type="submit"
                              >
                                <IonIcon icon={pencilOutline}></IonIcon>
                              </IonButton>
                            </IonCol>


                          </IonRow>
                        </IonGrid>

                        {/* Botões para alterar conta */}
                        <IonButton hidden={!showHabilitarEdicao}
                          style={{ height: "46px", fontSize: "18px" }}
                          onClick={async () => {

                            await alterarConta();
                            setShowHabilitarEdicao(false);
                          }}
                          expand="block"
                          type="submit"
                        >
                          Salvar
                        </IonButton>

                        <IonButton hidden={!showHabilitarEdicao}
                          style={{ height: "46px", fontSize: "18px" }}
                          onClick={async () => {
                            setListaItemProdutos(listaAnteriorParaCancelar);

                            const totalValor = listaAnteriorParaCancelar.reduce((total: any, item: any) => {
                              const itemValorNumerico = parseFloat(
                                item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
                              );
                              return total + itemValorNumerico;
                            }, 0);

                            console.log("Nova soma dos valores:", totalValor);

                            setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            }));

                            setShowHabilitarEdicao(false);
                          }}
                          expand="block"
                          type="submit"
                        >
                          Cancelar
                        </IonButton>

                        {/* Botões para enviar/salvar pedido */}
                        <IonButton hidden={!(temProdutosNovosAdicionados(listaItemProdutos))}
                          style={{ height: "46px", fontSize: "18px" }}
                          onClick={async () => {
                            setAlertRegistrar(true);
                          }}
                          expand="block"
                          type="submit"
                        >
                          {(dadosEmpresa.imprimirMesaParcial ? "Enviar" : "Salvar")}
                        </IonButton>

                        <IonButton hidden={!(temProdutosNovosAdicionados(listaItemProdutos))}
                          style={{ height: "46px", fontSize: "18px" }}
                          onClick={async () => {
                            const listaFiltrada = listaItemProdutos.filter((produto: any) => produto.salvo);
                            setListaItemProdutos(listaFiltrada);

                            const totalValor = listaFiltrada.reduce((total: any, item: any) => {
                              const itemValorNumerico = parseFloat(
                                item.subtotal.toString().replace(/\./g, '').replace(/\,/g, '.')
                              );
                              return total + itemValorNumerico;
                            }, 0);

                            // Exemplo: você pode armazenar a nova soma em outro estado ou usar conforme necessário
                            console.log("Nova soma dos valores:", totalValor);

                            setValorTotalProdutos(totalValor.toLocaleString('pt-br', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            }));
                          }}
                          expand="block"
                          type="submit"
                        >
                          Cancelar
                        </IonButton>

                        {/* Botão para fechar pedido */}
                        <IonButton hidden={showHabilitarEdicao || (temProdutosNovosAdicionados(listaItemProdutos))}
                          style={{ height: "46px", fontSize: "18px" }}
                          onClick={async () => {
                            setShowComandasFechar(true);
                          }}
                          expand="block"
                          type="submit"
                        >
                          Fechar {(window.localStorage.getItem("nomeInternoComandaOuMesa") || "Mesa")}
                        </IonButton>
                      </div>
                    </div>


                  </IonCardContent>
                </IonCard>
              </div>
            </IonCol>

          </IonRow>
        </IonGrid>

        <IonModal className="fullscreen-modal" isOpen={showComandasFechar} onDidDismiss={() => { setShowComandasFechar(false); }}>
          <ComandasFechar projetoid={params.id} imprimir={imprimir} imprimirFiscal={imprimirFiscal} closeAction={closeModalComandasFecharSucess} closeActionSimple={closeModalComandasFechar}></ComandasFechar>
        </IonModal>

        <IonModal isOpen={showModalTaxaServico} onDidDismiss={() => { closeModalTaxaServico(); }}>
          <TaxaServico projetoid={params.id} valorInicial={dadosComandas.taxaServico} modalAberto={showModalTaxaServico} closeAction={closeModalTaxaServicoSucess} closeActionSimple={closeModalTaxaServico}></TaxaServico>
        </IonModal>

        <IonModal isOpen={showModalDesconto} onDidDismiss={() => { closeModalDesconto(); }}>
          <Desconto projetoid={params.id} totalBase={valorTotalProdutos} valorInicial={descontoSelecionado} modalAberto={showModalDesconto} closeAction={closeModalDescontoSucess} closeActionSimple={closeModalDesconto}></Desconto>
        </IonModal>

        <IonModal isOpen={showModalTransferir} onDidDismiss={() => { closeModalTransferir(); }}>
          <Transferir projetoid={params.id} closeAction={closeModalTransferirSucess} closeActionSimple={closeModalTransferir}></Transferir>
        </IonModal>

        {/* Alerta para enviar/salvar pedido, com propriedade imprimirMesaParcial para gerar o cupom parcial do pedido */}
        <IonAlert isOpen={alertRegistrar}
          onDidDismiss={() => setAlertRegistrar(false)}
          header={(dadosEmpresa.imprimirMesaParcial ? "Enviar" : "Salvar") + " " + (window.localStorage.getItem("servicoTipo") || "Projeto")}
          message={'Deseja ' + (dadosEmpresa.imprimirMesaParcial ? "enviar" : "salvar") + ' o pedido da <strong>' + dadosComandas?.clienteNome + '</strong>?'}
          buttons={[
            {
              text: 'Cancelar',
              role: 'cancel',
            },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: async () => {

                setShowLoading(true);

                salvar(dadosEmpresa.imprimirMesaParcial)
                  .then(async (response: any) => {
                    console.log("Alteração bem-sucedida 1", response);

                    if (dadosEmpresa.imprimirMesaParcial) {
                      await gerarCupomParcial(response);
                    }
                  })
                  .then((response) => {
                    console.log("Alteração bem-sucedida 2", response);
                    history.goBack();
                  })
                  .catch((error) => {
                    console.log("Erro:", error.message);
                    setTextToast(error.message);
                    setShowToast(true);
                  })
                  .finally(() => {
                    setShowLoading(false);
                  });

              }
            }
          ]}
        />

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>
    </IonPage >
  );
};

export default ComandasProdutosMemory;